//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// CommonCode - Code to support working with React in conjunction with Telerik Controls and the omUIapi and general helper functions
//              Version 1.31 - November 19, 2022
// Note - this is the InteractMenu - Menu Version of CommonCode
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React from 'react';
import { SessionInfo } from "./App";
//import { useGoogleLogin } from 'react-use-googlelogin';
import { ENAppCnfg,ENLayoutCnfg } from './CommonInfo.js';
//const web3 = new Web3(window.web3.currentProvider); 
//const initScript = require()
//const sjcl = require('sjcl'); // Not sure about this - required for codec sub      
//var keypair = require("keypair");
const GoogleAuthContext = React.createContext();
//----------------------------------------------------------------------
//----------------------------------------------------------------------
const BlankImage = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAZABkDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD32iiigAooooAKKKKACiiigD//2Q==";
const CustomersO = [{ n: 'CustomerID',t: 24,p: 100 },{ n: 'FirstName',t: 21,p: 0 },{ n: 'AdditionalName',t: 21,p: 0 },{ n: 'LastName',t: 21,p: 0 },{ n: 'Address',t: 21,p: 0 },{ n: 'City',t: 21,p: 0 },{ n: 'ProvinceStateID',t: 24,p: 100 },{ n: 'CountryID',t: 24,p: 100 },{ n: 'PostalCode',t: 21,p: 0 },{ n: 'DateOfBirth',t: 34,p: 0 },{ n: 'Gender',t: 201,p: 0 },{ n: 'PhoneNumber',t: 21,p: 0 },{ n: 'PhoneNumber2',t: 21,p: 0 },{ n: 'EmailAddress',t: 21,p: 0 },{ n: 'EmailReceipts',t: 22,p: 0 },{ n: 'EmailPromotions',t: 22,p: 0 },{ n: 'SMSReminders',t: 22,p: 0 },{ n: 'SoundOn',t: 22,p: 0 },{ n: 'AutoScanLocation',t: 22,p: 0 },{ n: 'FlashOnScan',t: 22,p: 0 },{ n: 'CustomerIsInStore',t: 22,p: 0 },{ n: 'CustomerIsActive',t: 22,p: 0 },{ n: 'TotalPurchaseAmount',t: 28,p: 0 },{ n: 'MaximumPurchaseAmount',t: 28,p: 0 },{ n: 'TodayPurchaseAmount',t: 28,p: 0 },{ n: 'PersonPhotoID',t: 41,p: 0 },{ n: 'DeviceProfileID',t: 24,p: 100 },{ n: 'OMUserID',t: 24,p: 100 },{ n: 'AccessToken',t: 21,p: 0 },{ n: 'TransactionCount',t: 24,p: 0 },{ n: 'AbandonedSalesCount',t: 24,p: 0 },{ n: 'CardAddCount',t: 24,p: 0 },{ n: 'CustomerControls',t: 15,p: 0 },{ n: 'GeoLocation',t: 21,p: 0 },{ n: 'RoleID',t: 24,p: 100 },{ n: 'LastTimeActive',t: 35,p: 0 },{ n: 'LastStoreVisitedID',t: 24,p: 0 },{ n: 'StoreLocationID',t: 24,p: 100 },{ n: 'SublocationID',t: 24,p: 100 },{ n: 'StorePromotionID',t: 24,p: 100 },{ n: 'PurchaseFrequency',t: 24,p: 0 },{ n: 'PaceToken',t: 21,p: 0 },{ n: 'PaceID',t: 21,p: 0 },{ n: 'PacePassword',t: 21,p: 0 }];
//------ Object Definition For EntityConfiguration -- Date: 2024-06-06-9:05 AM ------
const EntityConfigurationOID = 546692;
const EntityConfigurationO = [{ n: 'EntityConfigurationID',t: 195,p: 100 },{ n: 'CompanyID',t: 195,p: 100 },{ n: 'StorePromotionID',t: 195,p: 100 },{ n: 'Promo1Link',t: 21,p: 0 },{ n: 'StorePromotion2',t: 195,p: 100 },{ n: 'Promo2Link',t: 21,p: 0 },{ n: 'StorePromotion3',t: 195,p: 100 },{ n: 'Promo3Link',t: 21,p: 0 },{ n: 'StorePromotion4',t: 195,p: 100 },{ n: 'Promo4Link',t: 21,p: 0 },{ n: 'GreetingMessage',t: 21,p: 0 },{ n: 'SecondMessage',t: 21,p: 0 },{ n: 'InputTextColor',t: 21,p: 0 },{ n: 'InputBGColor',t: 21,p: 0 },{ n: 'InputBorderColor',t: 21,p: 0 },{ n: 'InputFontType',t: 24,p: 0 },{ n: 'InputFontSize',t: 24,p: 0 },{ n: 'ButtonTextColor',t: 21,p: 0 },{ n: 'ButtonBGColor',t: 21,p: 0 },{ n: 'ButtonFontType',t: 24,p: 0 },{ n: 'ButtonFontSize',t: 24,p: 0 },{ n: 'HeadingTextColor',t: 21,p: 0 },{ n: 'HeadingFontType',t: 24,p: 0 },{ n: 'HeadingFontSize',t: 24,p: 0 },{ n: 'ItemNameColor',t: 21,p: 0 },{ n: 'ItemNameFontType',t: 24,p: 0 },{ n: 'ItemNameFontSize',t: 24,p: 0 },{ n: 'ItemNameFontWht',t: 24,p: 0 },{ n: 'ItemDescColor',t: 21,p: 0 },{ n: 'ItemDescFontType',t: 24,p: 0 },{ n: 'ItemDescFontSize',t: 24,p: 0 },{ n: 'ItemDescFontWht',t: 24,p: 0 },{ n: 'ListBGColor',t: 21,p: 0 },{ n: 'ListFontType',t: 24,p: 0 },{ n: 'ListFontSize',t: 24,p: 0 },{ n: 'ListHeadTextColor',t: 21,p: 0 },{ n: 'ListHeadBGColor',t: 21,p: 0 },{ n: 'HeadFontType',t: 24,p: 0 },{ n: 'HeadFontSize',t: 24,p: 0 },{ n: 'ListSectionTextColor',t: 21,p: 0 },{ n: 'ListSectionBGColor',t: 21,p: 0 },{ n: 'SectionFontType',t: 24,p: 0 },{ n: 'SectionFontSize',t: 24,p: 0 },{ n: 'PromptColor',t: 21,p: 0 },{ n: 'PromptFontType',t: 24,p: 0 },{ n: 'PromptFontSize',t: 24,p: 0 },{ n: 'PromoColor',t: 21,p: 0 },{ n: 'CartColor',t: 21,p: 0 },{ n: 'PurchasedColor',t: 21,p: 0 },{ n: 'BrandColor',t: 21,p: 0 },{ n: 'BrandLogo',t: 41,p: 0 },{ n: 'BackgroundImage',t: 41,p: 0 },{ n: 'DefaultStoreLocationID',t: 24,p: 0 },{ n: 'DefaultOrderType',t: 24,p: 0 },{ n: 'GeoFenceMeters',t: 24,p: 0 },{ n: 'RegistrationCode',t: 21,p: 0 },{ n: 'BaseDayOfWeek',t: 24,p: 0 },{ n: 'Tax1Percent',t: 16,p: 8 },{ n: 'Tax2Percent',t: 16,p: 8 },{ n: 'Tax3Percent',t: 16,p: 8 },{ n: 'ApplicationConfiguration',t: 15,p: 0 },{ n: 'LayoutConfiguration',t: 15,p: 0 },{ n: 'LastUpdatedOn',t: 35,p: 0 },{ n: 'ProcessCommand',t: 201,p: 0 },{ n: 'ApplicationTypeID',t: 195,p: 100 }];
//       Object Value Definition For EntityConfiguration
const ECV = { 'EntityConfigurationID': 0,'CompanyID': 0,'StorePromotionID': 0,'Promo1Link': '','StorePromotion2': 0,'Promo2Link': '','StorePromotion3': 0,'Promo3Link': '','StorePromotion4': 0,'Promo4Link': '','GreetingMessage': '','SecondMessage': '','InputTextColor': '','InputBGColor': '','InputBorderColor': '','InputFontType': 0,'InputFontSize': 0,'ButtonTextColor': '','ButtonBGColor': '','ButtonFontType': 0,'ButtonFontSize': 0,'HeadingTextColor': '','HeadingFontType': 0,'HeadingFontSize': 0,'ItemNameColor': '','ItemNameFontType': 0,'ItemNameFontSize': 0,'ItemNameFontWht': 0,'ItemDescColor': '','ItemDescFontType': 0,'ItemDescFontSize': 0,'ItemDescFontWht': 0,'ListBGColor': '','ListFontType': 0,'ListFontSize': 0,'ListHeadTextColor': '','ListHeadBGColor': '','HeadFontType': 0,'HeadFontSize': 0,'ListSectionTextColor': '','ListSectionBGColor': '','SectionFontType': 0,'SectionFontSize': 0,'PromptColor': '','PromptFontType': 0,'PromptFontSize': 0,'PromoColor': '','CartColor': '','PurchasedColor': '','BrandColor': '','BrandLogo': '','BackgroundImage': '','DefaultStoreLocationID': 0,'DefaultOrderType': 0,'GeoFenceMeters': 0,'RegistrationCode': '','BaseDayOfWeek': 0,'Tax1Percent': 0,'Tax2Percent': 0,'Tax3Percent': 0,'ApplicationConfiguration': 0,'LayoutConfiguration': 0,'LastUpdatedOn': new Date(),'ProcessCommand': 0,'ApplicationTypeID': 0 };
//       Object Index Definition For EntityConfiguration
const ECX = { 'EntityConfigurationID': 0,'CompanyID': 1,'StorePromotionID': 2,'Promo1Link': 3,'StorePromotion2': 4,'Promo2Link': 5,'StorePromotion3': 6,'Promo3Link': 7,'StorePromotion4': 8,'Promo4Link': 9,'GreetingMessage': 10,'SecondMessage': 11,'InputTextColor': 12,'InputBGColor': 13,'InputBorderColor': 14,'InputFontType': 15,'InputFontSize': 16,'ButtonTextColor': 17,'ButtonBGColor': 18,'ButtonFontType': 19,'ButtonFontSize': 20,'HeadingTextColor': 21,'HeadingFontType': 22,'HeadingFontSize': 23,'ItemNameColor': 24,'ItemNameFontType': 25,'ItemNameFontSize': 26,'ItemNameFontWht': 27,'ItemDescColor': 28,'ItemDescFontType': 29,'ItemDescFontSize': 30,'ItemDescFontWht': 31,'ListBGColor': 32,'ListFontType': 33,'ListFontSize': 34,'ListHeadTextColor': 35,'ListHeadBGColor': 36,'HeadFontType': 37,'HeadFontSize': 38,'ListSectionTextColor': 39,'ListSectionBGColor': 40,'SectionFontType': 41,'SectionFontSize': 42,'PromptColor': 43,'PromptFontType': 44,'PromptFontSize': 45,'PromoColor': 46,'CartColor': 47,'PurchasedColor': 48,'BrandColor': 49,'BrandLogo': 50,'BackgroundImage': 51,'DefaultStoreLocationID': 52,'DefaultOrderType': 53,'GeoFenceMeters': 54,'RegistrationCode': 55,'BaseDayOfWeek': 56,'Tax1Percent': 57,'Tax2Percent': 58,'Tax3Percent': 59,'ApplicationConfiguration': 60,'LayoutConfiguration': 61,'LastUpdatedOn': 62,'ProcessCommand': 63,'ApplicationTypeID': 64 };
// const StoreLocationsOID = 544596;
const StoreLocationsO = [{ n: 'StoreLocationID',t: 195,p: 100 },{ n: 'StoreName',t: 21,p: 0 },{ n: 'Description',t: 21,p: 0 },{ n: 'CompanyID',t: 195,p: 100 },{ n: 'LocationID',t: 195,p: 100 },{ n: 'StoreLocationControl',t: 15,p: 0 },{ n: 'AreaSize',t: 16,p: 0 },{ n: 'ContactID',t: 195,p: 100 },{ n: 'StoreGroupID',t: 195,p: 100 },{ n: 'TaxRate',t: 16,p: 0 },{ n: 'TaxRate2',t: 16,p: 0 },{ n: 'TaxRate3',t: 16,p: 0 },{ n: 'TaxRuleID',t: 195,p: 100 },{ n: 'MaximumPurchaseAmount',t: 28,p: 0 },{ n: 'StandardMarkupPercent',t: 16,p: 8 },{ n: 'ExtendedMarkupPercent',t: 16,p: 8 },{ n: 'SetPriceType',t: 201,p: 0 },{ n: 'SpecialtyList',t: 21,p: 0 },{ n: 'MarketingMessage',t: 21,p: 0 },{ n: 'PromotionalMessage',t: 21,p: 0 },{ n: 'ImageID',t: 41,p: 0 },{ n: 'StoreAmenities',t: 15,p: 0 },{ n: 'DayPeriods',t: 15,p: 0 },{ n: 'TipRate1',t: 16,p: 0 },{ n: 'TipRate2',t: 16,p: 0 },{ n: 'TipRate3',t: 16,p: 0 },{ n: 'CurrentInStoreWaitTime',t: 24,p: 0 },{ n: 'CurrentPickupWaitTime',t: 24,p: 0 },{ n: 'CurrentOrdersInQueue',t: 24,p: 0 },{ n: 'CurrentDeliveryWaitTime',t: 24,p: 0 }];
//       Object Value Definition For StoreLocations
const SLV = { 'StoreLocationID': 0,'StoreName': '','Description': '','CompanyID': 0,'LocationID': 0,'StoreLocationControl': 0,'AreaSize': 0,'ContactID': 0,'StoreGroupID': 0,'TaxRate': 0,'TaxRate2': 0,'TaxRate3': 0,'TaxRuleID': 0,'MaximumPurchaseAmount': 0,'StandardMarkupPercent': 0,'ExtendedMarkupPercent': 0,'SetPriceType': 0,'SpecialtyList': '','MarketingMessage': '','PromotionalMessage': '','ImageID': '','StoreAmenities': 0,'DayPeriods': 0,'TipRate1': 0,'TipRate2': 0,'TipRate3': 0,'CurrentInStoreWaitTime': 0,'CurrentPickupWaitTime': 0,'CurrentOrdersInQueue': 0,'CurrentDeliveryWaitTime': 0 };
//       Object Index Definition For StoreLocations
const SLX = { 'StoreLocationID': 0,'StoreName': 1,'Description': 2,'CompanyID': 3,'LocationID': 4,'StoreLocationControl': 5,'AreaSize': 6,'ContactID': 7,'StoreGroupID': 8,'TaxRate': 9,'TaxRate2': 10,'TaxRate3': 11,'TaxRuleID': 12,'MaximumPurchaseAmount': 13,'StandardMarkupPercent': 14,'ExtendedMarkupPercent': 15,'SetPriceType': 16,'SpecialtyList': 17,'MarketingMessage': 18,'PromotionalMessage': 19,'ImageID': 20,'StoreAmenities': 21,'DayPeriods': 22,'TipRate1': 23,'TipRate2': 24,'TipRate3': 25,'CurrentInStoreWaitTime': 26,'CurrentPickupWaitTime': 27,'CurrentOrdersInQueue': 28,'CurrentDeliveryWaitTime': 29 };
//  //------ Supported Fonts - NOTE - These are copied from InteractManager -------------------------------------------------
export const FontTypeValues = [{ n: 'Arial Unicode MS',k: 1 },{ n: 'Lucida Calligraphy',k: 2 },{ n: 'Verdana',k: 3 },{ n: 'Times New Roman',k: 4 },{ n: 'Franklin Gothic Medium',k: 5 },{ n: 'Brush Script MT',k: 6 },{ n: 'Lucida',k: 7 },{ n: 'Old English Text MT',k: 8 },{ n: 'Segoe Print',k: 9 },{ n: 'Rage',k: 10 },{ n: 'Trebuchet MS',k: 11 },{ n: 'Candra',k: 12 },{ n: 'Gadugi',k: 13 },{ n: 'Jokerman',k: 14 },{ n: 'Marlett',k: 15 },{ n: 'Ravie',k: 16 },{ n: 'Tahoma',k: 17 },{ n: 'Lexend',k: 18 }];
export const FontSizeValues = [{ n: '10px',k: 1 },{ n: '12px',k: 2 },{ n: '14px',k: 3 },{ n: '16px',k: 4 },{ n: '18px',k: 5 },{ n: '20px',k: 6 },{ n: '22px',k: 7 },{ n: '24px',k: 8 },{ n: '26px',k: 8 },{ n: '28px',k: 9 }];
export const FontWhtValues = [{ n: '100',k: 1 },{ n: '200',k: 2 },{ n: '300',k: 3 },{ n: '400',k: 4 },{ n: '500',k: 5 },{ n: '600',k: 6 },{ n: '700',k: 7 },{ n: '800',k: 8 },{ n: '900',k: 9 }];
//
// https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
// Note - control parm goes to y: used for parameter parsing - ActiveParm1, callParm goes to p - ActiveParm2 
//      - if control is not parm type - goes to ActiveParm1 with no parm
export default async function accessOMAPI(operation,control,tableID,key,rdata,modexMethod,optionColumns,callParm,pageID) {
  let CD;
  let result;
  let httpMethod;
  let SessionID = SessionInfo.session;
  if (!SessionID || SessionID === '')
    SessionID = "12345678990";
  let callOp = operation;
  if (SessionInfo.sequenceid < 100001) {
    if (SessionInfo.sequenceid > 100)
      trace(`Bad Call Sequence: ${SessionInfo.sequenceid} - set to 100001`);
    SessionInfo.sequenceid = 100001;
  }
  else
    SessionInfo.sequenceid += 1;
  if (Number.isInteger(tableID) === false) {
    console.log(`***> *NOT INTEGER* TableID: ${tableID} Operation: ${operation} Method: ${modexMethod}`);
    CD = { x: { s: '',q: '',t: 0,k: 0,i: 0,o: 0,y: 0,f: '',m: 'fail' },d: {} };
    return CD;
  }
  else if (Number.isInteger(key) === false) {
    key = parseInt(key,0);
    if (Number.isInteger(key) === false) {
      console.log(`***> *NOT INTEGER* Key: ${key} Operation: ${operation} Method: ${modexMethod}`);
      CD = { x: { s: '',q: '',t: 0,k: 0,i: 0,o: 0,y: 0,f: '',m: 'fail' },d: {} };
      return CD;
    }
  }
  if (!modexMethod)
    modexMethod = '';
  if (!optionColumns)
    optionColumns = '';
  if (!callParm)
    callParm = 0;
  if (!pageID)
    pageID = 0;
  //trace(`accessOMAPI SessionID: ${SessionID} SequenceID: ${SessionInfo.sequenceid} key: ${key} Operation: ${operation} control: ${control} callParm: ${callParm}`);
  try { //--------------------------------------------------------------------------------------------------- 
    if (operation < 100) {
      const RestHeader = { "Content-Type": "application/json; charset=utf-8" };
      httpMethod = "GET";
      let getCD = { x: { s: SessionID,q: SessionInfo.sequenceid,t: tableID,k: key,i: pageID,o: operation,y: control,p: callParm,f: modexMethod,m: optionColumns },d: {} };
      if (!rdata)
        rdata = {};
      getCD.d = rdata;
      //trace("GetCD: " + JSON.stringify(getCD)); 
      //trace("Get URI: " + JSON.stringify(SessionInfo.URI));
      const getData = encodeURI(SessionInfo.URI + '?CDataStr=' + JSON.stringify(getCD));  //  + '?CDataStr={x:{s:' + SessionID + ',q:' + SequenceID + ',t:' + tableID + ',k:' + key + ',y:0,o:' + operation + ',m:""},d:{}}');
      result = await fetch(getData,{ mode: "cors",headers: RestHeader });  // HTTP GET  , {request-no-cors}
      //trace("Get Result: " + JSON.stringify(result));
    } //----------------------------------------------------------------------------------------------------
    else {
      if (operation >= 100 && operation < 200) {
        httpMethod = "POST";
        operation -= 100;
      }
      else if (operation >= 200 && operation < 300) {
        httpMethod = "PUT";
        operation -= 200;
      }
      else if (operation >= 300 && operation < 400) {
        httpMethod = "PATCH";
        operation -= 300;
      }
      else if (operation >= 400 && operation < 500) {
        httpMethod = "DELETE";
        operation -= 400;
      }
      else {
        httpMethod = "UNKNOWN";
      }
      let updata = { x: { s: SessionID,q: SessionInfo.sequenceid,t: tableID,k: key,i: pageID,o: operation,y: control,p: callParm,f: modexMethod,m: optionColumns },d: {} };
      if (rdata === undefined)
        rdata = {};
      updata.d = rdata;
      let upstr = JSON.stringify(updata);
      //trace(`Access: '${httpMethod}' Command: ${upstr}`);
      const RestHeader = {
        "Content-Type": "application/json; charset=utf-8",
        "Content-Length": upstr.length
      };
      //trace(`Update Header: ${JSON.stringify(RestHeader)}`); 
      //trace(`Put URI: ${JSON.stringify(SessionInfo.URI)}`);
      result = await fetch(SessionInfo.URI,{
        method: httpMethod, // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, cors, *same-origin
        headers: RestHeader,
        body: upstr // body data type must match "Content-Type" header
      });
    }//---------------------------------------------------------------------------------------------------
    //trace("result: " + JSON.stringify(result)); //- this displays {}
    CD = await result.json();
    //trace(`${httpMethod} post CD: ${JSON.stringify(CD)}`); // GET post CD: - PUT post CD:
    if (!CD) { // undefined for 61 ping and 20 trace
      if (callOp >= 101 && callOp <= 109) { // logon or register
        console.log(`***> OMAPI logon or register: ${callOp} returned NULL CD (${SessionInfo.commErrorCount})`); // 20 is OMTrace
        CD = { x: { s: '',q: '',t: 0,k: 0,i: 0,o: 9990,y: 0,f: '',m: 'fail' },d: {} };
      } else {
        if (callOp !== 20 && callOp !== 61) { // Don't want to log this for (phone)trace or ping 
          console.error(`***> Bad CD - Undefined -  operation: ${callOp}`);
          console.log(`***> OMAPI operation: ${callOp} returned NULL CD (${SessionInfo.commErrorCount})`); // 20 is OMTrace
          if (++SessionInfo.commErrorCount > 5)
            await LogOffResetMsg(SessionInfo.props,"Unable To Access Server");
          else
            displayError("Unable to Access Server");
          handleRestart(1); // Restart the application
        }
        CD = { x: { s: SessionID,q: SessionInfo.sequenceid,t: 0,k: 0,i: 0,o: 0,y: 0,f: '',m: '' },d: {} };
      }
    }
    else { // CD Defined
      if (SessionInfo.traceDebug === true)
        trace(`OMAPI operation: ${operation}-(${callOp}) - Method: ${modexMethod}, logged on: ${SessionInfo.loggedOn} - returned CD.x: (${JSON.stringify(CD.x)}), call Data: ${JSON.stringify(rdata)}`);  
      if (!CD.x || !CD.x.s) {
        if (!CD.x)
          console.error(`***> Bad CD: ${JSON.stringify(CD)}`);
        else if (!CD.x.s && SessionInfo.loggedOn === true)
          console.error(`***> Bad CD Session: ${JSON.stringify(CD)}`);
        if (callOp !== 20 && callOp !== 61) {
          if (CD.status && CD.status == 400) {
            let propExist = SessionInfo.props != undefined;
            console.log(`***> Status 400 Comm Failure - go to logon - props: ${propExist}`);
            await LogOff(false);
            SessionInfo.forceLogoff = true;
            if (SessionInfo.props)
              SessionInfo.props.navigate("/Login");
          } else
            await LogOffResetMsg("Error on Access to Server");
          //handleRestart(2); // Restart the application
          return;
        }
      }
      if (callOp < 100 || callOp > 110) { // NOT Signon/Register
        if (CD.x.o > 9800) { // Error Level in OMAPI - 23May24 - Should this check for o=0?
          console.log(`***> accessOMAPI - application call issue - CD: ${JSON.stringify(CD)}`);
          if (CD.x.o > 9900) { // Severe Error Level in OMAPI - NOTE: 9900 is the standard o level for OMO.AddError in OM
            trace(`Call LogOffReset in accessOMAPI`);
            await LogOffReset(`LogOff Error: ${CD.x.o} operation: ${operation}`,1); // Error Forced Logoff and Relogon
            CD = { x: { s: SessionID,q: SessionInfo.sequenceid,t: 0,k: 0,i: 0,o: 0,y: 0,f: '',m: '' },d: {} }; // o - 9996 - Force Logon
          }
        }
      }
      SessionInfo.session = CD.x.s;
      if (SessionInfo.commErrorCount > 0) {
        trace(`Access to Server Restored - Count: ${SessionInfo.commErrorCount}`);
        SessionInfo.commErrorCount = 0;
      }
    }
    //trace("SessionInfo.commErrorCount: " + SessionInfo.commErrorCount);
  } catch (error) { //****** COMM ERROR ***************
    console.error(`Fail accessOMAPI: ${httpMethod} Op: ${operation} (${SessionInfo.commErrorCount}) - Error: ${error.message}`);
    //if (++SessionInfo.commErrorCount > 5) {
      await LogOffResetMsg("Lost Access to Server");
    console.log(`***> Comms Cancelled due to no connection (${SessionInfo.commErrorCount}) - restart`);
    handleRestart(3); // Restart the application
    //}
    //else {
    //  displayError(`Unable to Access Server (${SessionInfo.commErrorCount})`);
    //}                                                                                                                             
    //CD = { x: { s: SessionID,q: SessionInfo.sequenceid,t: 0,k: 0,i: 0,o: 9997,y: 0,f: '',m: '' },d: {} }; // o - 9997 - Comms Error
    CD = { x: { s: 'XXXX',q: 0,t: 0,k: 0,i: 0,o: 9997,y: 0,f: '',m: '' },d: {} }; // o - 9997 - Comms Error
  }
  return CD;
}
function CreateLogonDict(keyValue,userName,password) { // For Interact-Menu - create list of values to send to OM 
  let dt = new Date();
  let timeAdjust = -dt.getTimezoneOffset();
  if (SessionInfo.debug === true) // 21Nov23 - this is causing a problem with dates
    timeAdjust = 0;
  let manufacturer = window.navigator.language; //window.navigator.DeviceInfo.manufacturer; 
  if (!manufacturer)
    manufacturer = "browser";
  //trace(`CreateLogonDict - geolocation: ${JSON.stringify(window.navigator.geolocation)}, Manufacturer: ${manufacturer}`); // Current Location
  //let deviceName = navigator.userAgentData.platform; // window.navigator.platform; // Device Name (Motz's iPhone)
  //if (!deviceName)
  let deviceName = "webphone";
  //else
  //  deviceName = deviceName.toString();
  //let platform = navigator.userAgentData.platform; // window.navigator.appName; // Platform (Android)
  //if (!platform)
  let platform = "React";
  let appName = "InteractMenu"; // Idiom: MenuApp - See LogonToOM in OM
  let Timezone = window.navigator.timezone;
  if (!Timezone)
    Timezone = "unknown";
  let deviceType = window.navigator.language; // Device Type (Physical)
  if (!deviceType)
    deviceType = "unknown";
  let currentTime = new Date();
  if (!currentTime)
    currentTime = "Unknown";
  SessionInfo.Width = window.innerWidth;
  SessionInfo.Height = window.innerHeight;
  SessionInfo.DomainName = SessionInfo.host;
  //trace(`timezone: ${Timezone}, deviceType: ${deviceType}, widxht: ${SessionInfo.Width}X${SessionInfo.Height}`); // Current Location
  let ldata = {
    UserName: userName,Password: password,AppProductID: SessionInfo.AppProductID.toString(),AppSiteID: SessionInfo.AppSiteID.toString(),AppEntityID: SessionInfo.AppEntityID.toString(),RegCode: SessionInfo.registrationCode,DomainName: SessionInfo.host,TimeAdjust: timeAdjust.toString(),KeyValue: keyValue,Manufacturer: manufacturer,OptiVersion: SessionInfo.appVersion.toString(),Platform: platform,AppName: appName,SystemName: deviceName,Width: SessionInfo.Width.toString(),Height: SessionInfo.Height.toString(),CC: SessionInfo.CC.toString()
  }; // Name: deviceName}; // Platform: platform, AppName: appName, OptiVersion: SessionInfo.appVersion,DeviceType: deviceType.toString(), TimeZone: Timezone.toString(), DaylightSavings: "N", Time: currentTime.toString()};
  if (SessionInfo.traceDebug)
    trace(`==> Logon Dict: ${JSON.stringify(ldata)}`);
  return ldata;
}
// Change Password Functions - Request PWReset - sends email with link and Token - click on Link - Get Token contents - change password
export async function RequestPWReset(userName,password) {
  trace(`Request PW Reset - userName: ${userName}, pw: ${password}, AppProductID: ${SessionInfo.AppProductID}, AppEntityID: ${SessionInfo.AppEntityID}`);
  if (!SessionInfo.AppProductID)
    SessionInfo.AppProductID = 270;
  if (!SessionInfo.AppEntityID)
    SessionInfo.AppEntityID = 0;
  let ldata = CreateLogonDict("",userName,password);
  const CD = await accessOMAPI(106,0,SessionInfo.AppProductID,SessionInfo.AppEntityID,ldata); // LogonToOM in OMAccess - Note: Logon to OM causes LogonCheckCustomer in CheckoutMdx to be executed
}
export async function GetPWCToken(token) {
  trace(`Get PWC - AppProductID: ${SessionInfo.AppProductID}, AppEntityID: ${SessionInfo.AppEntityID}, ${JSON.stringify(token)}`);
  if (!SessionInfo.AppProductID)
    SessionInfo.AppProductID = 270;
  if (!SessionInfo.AppEntityID)
    SessionInfo.AppEntityID = 0;
  const CD = await accessOMAPI(111,0,SessionInfo.AppProductID,SessionInfo.AppEntityID,token); // Token Value Retrieval - this information is used to verify the user changing the password
  trace(`Return PWC - CD: ${JSON.stringify(CD)}`);
  return CD;
}
export async function ChangePassword(emailAddress,password,confirmPassword,changeToken) {
  trace(`change Password for Email: ${emailAddress}, password: ${password}, changeToken: ${changeToken}`);
  try {
    if (!SessionInfo.AppProductID)
      SessionInfo.AppProductID = 270;
    if (!SessionInfo.AppEntityID)
      SessionInfo.AppEntityID = 0;
    let appProductID = '';
    let appSiteID = '';
    let appEntityID = '';
    let email = '';
    let token = '';
    if (changeToken == "Session") {
      appProductID = String(SessionInfo.AppProductID);
      appSiteID = String(SessionInfo.AppSiteID);
      appEntityID = String(SessionInfo.AppEntityID);
      token = SessionInfo.session;
    } else {
      let values = changeToken.split('|');
      trace(`values: ${JSON.stringify(values)}`);
      //let keyValues = `${emailAddress}|${password}|${confirmPassword}|${changeToken}`;
      appProductID = values[0];
      appSiteID = values[1];
      appEntityID = values[2];
      email = values[3];
      token = values[4];
    }
    trace(`Change Password: token: ${token}`);
    let password2 = "";
    let keyValues = { "Email": emailAddress,"Password": password,"ConfirmPassword": confirmPassword,"Password2": password2,"AppProductID": appProductID,"AppSiteID": appSiteID,"AppEntityID": appEntityID,"Control": "PWC","User": String(SessionInfo.OMUserID),"changeToken": token };
    const CD = await accessOMAPI(107,2,SessionInfo.AppProductID,SessionInfo.AppEntityID,keyValues);
    trace(`Change Password Confirmation CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful Confirmation
      SessionInfo.session = CD.x.s;
      if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
        if (CD.x.q > 100) // 1 Indicates Initial response after signon
          console.log(`***> Bad Return Sequence (1) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
      }
      SessionInfo.sequenceid = CD.x.q;
      SessionInfo.logonName = "";
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonEmailAddress = "";
      SessionInfo.commErrorCount = 0;
      trace(`Confirmation ID: ${CD.x.s} set: ${SessionInfo.session}`);
      return CD.x.m;
    }
    else
      return CD.x.m;
  }
  catch (Ex) {
    await OMTrace(2,`Failure in ChangePassword: ${Ex.Message}`);
  }
}
export function handleRestart(callparm) {
  console.log(`Restarting Application (${callparm}) - Logged On: ${SessionInfo.loggedOn === true}`);
  if (SessionInfo.loggedOn === true)
    window.location.reload();
};
//------------------------------------------------------
function getDisplayName() {
  let nameChk = SessionInfo.PersonInfo.FirstName;
  if (!nameChk || nameChk.length < 3)
    nameChk = SessionInfo.PersonInfo.EmailAddress;
  if (!nameChk || nameChk.length < 3)
    nameChk = SessionInfo.logonEmailAddress;
  if (!nameChk || nameChk.length < 3)
    nameChk = SessionInfo.logonName;
  if (nameChk) {
    if (nameChk.length > 17) {
      let ix = nameChk.indexOf('@');
      if (ix > 2)
        nameChk = nameChk.substring(0,ix);
      if (nameChk.length > 17) {
        let ix = nameChk.indexOf('.');
        if (ix > 2)
          nameChk = nameChk.substring(0,ix);
        if (nameChk.length > 17) {
          nameChk = nameChk.substring(0,17);
        }
      }
    }
  }
  return nameChk;
}
//------------------------------------------------------
//------ Standard Logon ---------------------------------
// Log on, signon, sign on, Login, log in
export async function LogOn(userName,password,keyToken) {
  trace(`Logon - userName: ${userName}, pw: ${password}, token: ${keyToken}`);
  SessionInfo.forceLogoff = false;
  if (!keyToken)
    keyToken = "";
  let ldata = CreateLogonDict(keyToken,userName,password);
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(`--> LogOn with ldata: ${JSON.stringify(ldata)}`);
  let logonType = 200;
  if (SessionInfo.isPhoneLogin === true)
    logonType = 201;
  // Note - Logon with 101 logon returns RoleID and CustomerControl (KeyLogon does not and require Customer Control to get RoleID)
  const CD = await accessOMAPI(101,logonType,0,0,ldata); // LogonToOM in OMAccess - Note: Logon to OM causes LogonCheckCustomer in CheckoutMdx to be executed
  if (!CD) {
    displayError('Logon Failed (1) - Communication Problem');
  }
  else {
    trace(` Standard LogOn CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful logon
      SessionInfo.session = CD.x.s;
      SessionInfo.AppEntityID = CD.x.t;
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonType = 1;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 9-default logon
      SessionInfo.defaultLogon = false;
      SessionInfo.accountLogon = true;
      if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
        if (CD.x.q > 100) // 1 Indicates Initial response after signon
          console.log(`***> Bad Return Sequence (2) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
      }
      SessionInfo.sequenceid = CD.x.q;
      let ret = await SetConfigInfo(CD.d,userName); // Data returned from logon (101)
      return ret;
    }
    else
      return CD.x.m;
  }
}
export async function SendVerifyCode(phoneNumber) {
  SessionInfo.forceLogoff = false;
  trace(`SendVerifyCode - number: ${phoneNumber}`);
  let ldata = CreateLogonDict(phoneNumber,phoneNumber,phoneNumber);
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(` SendVerify with ldata: ${JSON.stringify(ldata)}`);
  let logonType = 210; // Logon type - information only
  const CD = await accessOMAPI(101,logonType,0,0,ldata); // Send verification code
  console.log(`After SendVerifyCode - CD: ${JSON.stringify(CD)}`);
  if (!CD) {
    displayError('Logon Failed (2) - Communication Problem');
  }
  else {
    trace(` SendVerify CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful - verification code sent to users phone
      SessionInfo.verificationCode = CD.x.m; 
      SessionInfo.session = CD.x.s; // Added 7Mar25
      SessionInfo.AppEntityID = CD.x.t;
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonType = 8;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 8-Phone Logon, 9-default logon
      SessionInfo.defaultLogon = false;
      SessionInfo.accountLogon = false;
      SessionInfo.sequenceid = CD.x.q;
      SessionInfo.CC = CD.x.i;
      let ret = "ok"; // await SetConfigInfo(CD.d,phoneNumber); // Data returned from logon (101)
      return ret;
    }
    else
      return CD.x.m;
  }
}
export async function LogonWithPhone(phoneNumber) {
  SessionInfo.forceLogoff = false;
  trace(`LogonWithPhone - number: ${phoneNumber}`);
  let ldata = CreateLogonDict(phoneNumber,phoneNumber,phoneNumber);
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(`--> Logon Phonenumber ldata: ${JSON.stringify(ldata)}`);
  let logonType = 202; // phone only logon 
  const CD = await accessOMAPI(101,logonType,0,0,ldata); // Send verification code
  if (!CD) {
    displayError('Logon Failed (3) - Communication Problem');
  }
  else {
    trace(` Phone LogOn CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful logon code
      SessionInfo.verificationCode = CD.x.m;   
      SessionInfo.session = CD.x.s; // Added 7Mar25
      SessionInfo.AppEntityID = CD.x.t;
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonType = 8;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 8-Phone logon, 9-default logon
      SessionInfo.defaultLogon = false;
      SessionInfo.accountLogon = true;
      SessionInfo.sequenceid = CD.x.q;
      let ret = await SetConfigInfo(CD.d,phoneNumber); // Data returned from logon (101)
      return ret;
    }
    else
      return CD.x.m;
  }
}
export async function LogonWithPhoneVerify(phoneNumber,verify) {
  SessionInfo.forceLogoff = false;
  trace(`LogonWithPhoneVerify - number: ${phoneNumber}, verify: ${verify}`);
  let ldata = CreateLogonDict(verify,phoneNumber,phoneNumber);
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(` Logon Phonenumber Verify ldata: ${JSON.stringify(ldata)}`);
  let logonType = 201; // phoneConfirm with SMS code
  const CD = await accessOMAPI(101,logonType,0,0,ldata); // Send verification code
  if (!CD) {
    displayError('Logon Failed (4) - Communication Problem');
  }
  else {
    trace(` Phone LogOn CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful logon code
      SessionInfo.verificationCode = CD.x.m;      
      SessionInfo.session = CD.x.s; // Added 7Mar25
      SessionInfo.AppEntityID = CD.x.t;
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonType = 8;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 8-Phone Logon, 9-default logon
      SessionInfo.defaultLogon = false;
      SessionInfo.accountLogon = true;
      SessionInfo.sequenceid = CD.x.q;
      let ret = await SetConfigInfo(CD.d,phoneNumber); // Data returned from logon (101)
      return ret;
    }
    else
      return CD.x.m;
  }
}
//------ Default Logon ---------------------------------
export async function LogOnDefault() {
  let userName = "none";
  trace(`LogonDefault - userName: ${userName}, AppProductID: ${SessionInfo.AppProductID}, AppEntityID: ${SessionInfo.AppEntityID}`);
  let ldata = CreateLogonDict("","","");
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(` LogOn Default ldata: ${JSON.stringify(ldata)}`);
  const CD = await accessOMAPI(109,0,0,0,ldata);
  if (!CD) {
    displayError('Default Logon Failed - Communication Problem');
  }
  else {
    trace(` Default LogOn CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful DEFAULT logon
      SessionInfo.session = CD.x.s;
      SessionInfo.AppEntityID = CD.x.t;
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonType = 9;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 9-default (No) logon
      SessionInfo.defaultLogon = true;
      SessionInfo.accountLogon = false;
      if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
        if (CD.x.q > 100) // 1 Indicates Initial response after signon
          console.log(`***> Bad Return Sequence (3) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
      }
      SessionInfo.sequenceid = CD.x.q;
      let ret = await SetConfigInfo(CD.d,userName); // Data returned from default logon (109) 
      return ret;
    }
    else
      return CD.x.m;
  }
}
export async function mainLogon(token) {
  if (!token)
    token = SessionInfo.CheckoutToken;
  SessionInfo.forceLogoff = false;
  //trace(`main Logon - Keylogon with token: ${token}`);
  let m = await KeyLogOn(token); // Token - Decrypted: : '270	2000008	3000487	ChkOut	BLRE+jaPAp4ErnYc6SXJBNHruLSVGhHNR9JXC+hsGCc=		1	6002102			chkout	127.0.0.1' - pw: 'Checkout4#|60021023000487270'
  SessionInfo.keyLogon = false;
  //trace(`After KeyLogon msg: ${m}`);
  if (m === 'ok') {
    trace(`Auto Signed In - UpdateCustomer - SessionID: ${SessionInfo.session}, AutoPage: ${SessionInfo.gotoAutoPage}`);
    SessionInfo.AutoLogonDone = false;
    // 10May24 - this is causing white screen of death - and causing omUIapi to fail - this needs be investigated
    //if (SessionInfo.debug == true) { // Get extended control from parms (encrypted) 
    //  let CD = await accessOMAPI(135,0,0,1142,SessionInfo.entx,"CheckoutMdx_UpdateCustomer"); // Test
    //}     
    if (SessionInfo.props)
      SessionInfo.props.navigate(`/${SessionInfo.gotoAutoPage}`);
  }
  else {
    trace(`Unable to Login: ${m} - Deleting the Logon Token - AppEntityID: ${SessionInfo.AppEntityID}`);
    //if (SessionInfo.EntCookie === true)
    //  deleteCookie(`IMSecure${+SessionInfo.AppEntityID.toString()}ID`); // Delete the cookie with the logon token 
    //else
    //  deleteCookie(`IMSecureID`); // Delete the cookie with the logon token
    SessionInfo.loggedOn = false;
    if (SessionInfo.props)
      SessionInfo.props.navigate("/Login"); // Logon
  }
}
//------ Key Logon ---------------------------------
export async function KeyLogOn(token) {
  trace(`KeyLogon - Token: ${token}`);
  let ldata = CreateLogonDict(token,"","");
  trace(`Key logon ldata: ${JSON.stringify(ldata)}`);
  let logonType = 203; // phone token logon 
  const CD = await accessOMAPI(104,logonType,0,0,ldata);
  if (!CD) {
    trace(`Key Logon Failed - CD Null - dict: ${JSON.stringify(ldata)}`);
    //displayError('Key Logon Failed - Communication Problem');
    console.log(`Key Logon Invalid`);
    return 'Failure';
  }
  else {
    if (SessionInfo.traceDebug)
      trace(`Key LogOn CD: ${JSON.stringify(CD)}`);
    if (CD.x.o < 9500) { // Successful logon
      if (!CD.x.s || CD.x.s === null || CD.x.s === '') {
        trace(`Key LogOn Null Session`);
        return 'Failure';
      } else {
        SessionInfo.session = CD.x.s;
        SessionInfo.AppEntityID = CD.x.t;
        SessionInfo.OMUserID = CD.x.k;
        SessionInfo.logonType = 4;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 9-default logon
        SessionInfo.defaultLogon = false;
        SessionInfo.accountLogon = true;
        //trace(`---> Key Logon Type: ${SessionInfo.logonType}`); // Note - May be default logon  
        if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
          if (CD.x.q > 100) // 1 Indicates Initial response after signon
            trace(`***> Bad Return Sequence (4) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
        }
        SessionInfo.sequenceid = CD.x.q;
        let ret = await SetConfigInfo(CD.d,CD.x.m); // Data returned from key logon (104)               
        return ret;
      }
    }
    else {
      return 'Failure';
    }
  }
}
//---------------------------------------
export async function SetConfigInfo(list,email) { // List is data returned from OM at logon or register 
  trace(`====> SetConfigInfo: ${JSON.stringify(list)}`);
  SessionInfo.ResetOrder = false; // Make sure that this is reset on logon
  if (list) {
    SessionInfo.commErrorCount = 0;
    SessionInfo.logonName = getDisplayName();
    SessionInfo.logonEmailAddress = email; // Should return email address from logon (and phonenumber)     
    //trace(`Logon Set Config - name: ${JSON.stringify(SessionInfo.logonName)}, email: ${JSON.stringify(SessionInfo.logonEmailAddress)}`);
    try {
      trace(`After Logon - SetConfigInfo - Parms List: ${JSON.stringify(list)}, email: ${JSON.stringify(SessionInfo.logonEmailAddress)}`);
      trace(`            - SessionInfo.stayLoggedOn: ${SessionInfo.stayLoggedOn}, SessionInfo.CheckoutToken: ${SessionInfo.CheckoutToken}`);
      if (list["ALKey"]) {
        if (SessionInfo.stayLoggedOn === true) {
          SessionInfo.CheckoutToken = list["ALKey"];
          if (SessionInfo.EntCookie === true)
            setCookie(`IMSecure${SessionInfo.AppEntityID.toString()}ID`,SessionInfo.CheckoutToken,180);
          else
            setCookie(`IMSecureID`,SessionInfo.CheckoutToken,180);
        }
      }
      if (list["ApplicationTypeID"])
        SessionInfo.ApplicationTypeID = list["ApplicationTypeID"];
      else
        SessionInfo.ApplicationTypeID = 100;
      trace(`--> DefaultStoreLocationID: ${list.DefaultStoreLocationID}, StoreLocationID: ${SessionInfo.StoreLocationID}`);
      if (list.DefaultStoreLocationID && (!SessionInfo.StoreLocationID || SessionInfo.StoreLocationID === 0))
        SessionInfo.StoreLocationID = list.DefaultStoreLocationID;
      trace(`storelocationid: ${SessionInfo.StoreLocationID}`);
      if (list["LastLogonDate"])
        SessionInfo.PersonInfo.LastLogonDate = list["LastLogonDate"];
      if (list["RoleID"]) {
        SessionInfo.RoleID = parseInt(list["RoleID"]);
        SessionInfo.PersonInfo.RoleID = SessionInfo.RoleID;
        SessionInfo.PermLevel = SessionInfo.RoleID + 220;
        trace(`--> Logon - RoleID: ${SessionInfo.RoleID}, Perm: ${SessionInfo.PermLevel}, ApplicationTypeID: ${SessionInfo.ApplicationTypeID}, UserID: ${SessionInfo.OMUserID}, Entity: ${SessionInfo.AppEntityID}, Session: ${SessionInfo.session} `);
      }
      if (list["GeoFenceMeters"])
        SessionInfo.GeoFenceMeters = parseInt(list["GeoFenceMeters"]);
    }
    catch (Ex) {
      await OMTrace(2,`Failure in SetConfigInfo  ${Ex.Message}`);
    }
    if (CheckPermission(SessionInfo.PermLevel) == false) {
      OMTrace(`Permission Verification Failed - User: ${SessionInfo.userID}, ${SessionInfo.logonName}, Role: ${SessionInfo.RoleID}`);
      return "Permission Verification Failed";
    } else { // Permission OK - Logged on
      SessionInfo.loggedOn = true;
      await GetCustomerInfo(); // Get Configuration Data - the only place this is called  
      if (SessionInfo.RoleID > 272 && SessionInfo.AC.HasManagerPage === true) {   
        trace(`Set AutoPage - RoleID: ${SessionInfo.RoleID}`);
        SessionInfo.gotoAutoPage = 'ManagerPage';
      }  else { // First - determine if the user has an open order 
        let CD = await CallOM("GetCustomOrderForUser",0,SessionInfo.StoreLocationID); // Get OrderItems with the image (MOID=0)  
        trace(`GetCustomOrderForUser: ${JSON.stringify(CD)}, Curr LocationID: ${SessionInfo.StoreLocationID}`);
        if (CD.x.o < 9500) { // 9500 is AddWarning level - meaning order not found - or temporary user
          let row = CD.d;
          //SessionInfo.CurrentOrder = row; // Added Jan 21 - test to see if needed
          SessionInfo.CustomOrderID = row.CustomOrderID;
          SessionInfo.OrderType = row.CustomOrderType;
          SessionInfo.ItemCount = row.ItemCount; // Problem - sometimes this is full item count (with SL Items) - sometimes just actual order Items? - See GetCustomOrderTotal for proper calc.
          SessionInfo.SLItemCount = row.SLItemCount;
          SessionInfo.gotoAutoPage = 'OrderPage';
          if (row.CustomOrderType == 3)
            SessionInfo.gotoAutoPage = 'ScannerPage';
          if (row.StoreLocationID != SessionInfo.StoreLocationID) { // Set the Current Location & Table according the Active Order information 
            SessionInfo.StoreLocationID = row.StoreLocationID;
            SessionInfo.CurrentTableID = row.SublocationID;
            await GetLocationInfo(SessionInfo.StoreLocationID,SessionInfo.CurrentTableID);
          }
          trace(`CustomOrderID: ${SessionInfo.CustomOrderID}, StoreLocationID: ${SessionInfo.StoreLocationID}, gotoAutoPage: ${SessionInfo.gotoAutoPage}, OrderType: ${SessionInfo.OrderType}, ItemCount: ${SessionInfo.ItemCount}, SLCount: ${SessionInfo.SLItemCount}`);
        }
        trace(`Get Customer Info Complete - Get Entity Config - AutoPage: ${SessionInfo.gotoAutoPage}`);
      }
      if (SessionInfo.gotoAutoPage === '') {
        if (SessionInfo.HasLandingPage === true && SessionInfo.AC.HasLandingPage === true)
          SessionInfo.gotoAutoPage = 'LandingPage';
        else
          SessionInfo.gotoAutoPage = 'OrderPage';
      }
      trace(`==> After Cust Config -  gotoAutoPage: ${JSON.stringify(SessionInfo.gotoAutoPage)}, name: ${JSON.stringify(SessionInfo.logonName)}, email: ${JSON.stringify(SessionInfo.logonEmailAddress)}, ApplicationTypeID: ${SessionInfo.ApplicationTypeID}, HasLandingPage: ${SessionInfo.HasLandingPage}`);
      return "ok";
    }
  } else
    return "fail";
}
function setSessionAC() { // Set Session AC values based on ApplicationTypeID
  trace(`setAC - ApplicationTypeID: ${SessionInfo.ApplicationTypeID}`);
  if (SessionInfo.ApplicationTypeID < 20) {
    if (SessionInfo.ApplicationTypeID < 6) {
      SessionInfo.AC.HasManagerPage = false;
      if (SessionInfo.ApplicationTypeID < 5) {
        if (SessionInfo.ApplicationTypeID < 4) {
          SessionInfo.AC.HasScanAndPay = false;
          SessionInfo.AC.HasReceipts = false;
          SessionInfo.AC.HasMyAccount = false;
          SessionInfo.AC.HasHelp = false;
          SessionInfo.AC.HasLogoff = false;

          SessionInfo.AC.HasOrderType = false;
          SessionInfo.AC.HasTable = false;
          SessionInfo.AC.HasGuest = false;
          SessionInfo.AC.HasViewSeats = false;
          SessionInfo.AC.HasDietControl = false;

          if (SessionInfo.ApplicationTypeID < 3) {
            SessionInfo.AC.HasFavorites = false;
            if (SessionInfo.ApplicationTypeID < 2) {
              SessionInfo.AC.HasLandingPage = false;
              // Menu Control
              SessionInfo.AC.HasShoppingCart = false;
              SessionInfo.AC.HasTotals = false;
              SessionInfo.AC.HasQuickAdd = false;
              SessionInfo.AC.HasPromotion = false;
              SessionInfo.AC.HasDetail = false;
            }
          }
        }
      }
    }
  }
  if (SessionInfo.defaultLogon === true || SessionInfo.AppCfg.HasSeats === false)
    SessionInfo.AC.HasViewSeats = false;
  if (SessionInfo.defaultLogon === true)
    SessionInfo.AC.HasGuest = false;
}
// Set State Variables for Encoded Bit-Values For ApplicationConfiguration
// ** Add to getRecord  await this.setApplicationConfigurationBitEncoded(row[elem.n])
function setApplicationConfigurationControls(ApplicationConfigurationVals) { // Note - Modified
  trace(`Set ApplicationConfiguration Controls`);
  if ((ApplicationConfigurationVals & (0x001 << 1)) === (0x001 << 1))
    SessionInfo.AppCfg.ScanAndPay = true;
  else
    SessionInfo.AppCfg.ScanAndPay = false;
  if (SessionInfo.ApplicationTypeID <= 3)
    SessionInfo.AppCfg.ScanAndPay = false;
  if ((ApplicationConfigurationVals & (0x001 << 2)) === (0x001 << 2))
    SessionInfo.AppCfg.OrderAndPay = true;
  else
    SessionInfo.AppCfg.OrderAndPay = false;
  if ((ApplicationConfigurationVals & (0x001 << 3)) === (0x001 << 3))
    SessionInfo.AppCfg.ScanPayIndividualItems = true;
  else
    SessionInfo.AppCfg.ScanPayIndividualItems = false;
  if ((ApplicationConfigurationVals & (0x001 << 5)) === (0x001 << 5))
    SessionInfo.AppCfg.HasIngredients = true;
  else
    SessionInfo.AppCfg.HasIngredients = false;
  if ((ApplicationConfigurationVals & (0x001 << 6)) === (0x001 << 6))
    SessionInfo.AppCfg.HasOrderToTable = true;
  else
    SessionInfo.AppCfg.HasOrderToTable = false;
  if ((ApplicationConfigurationVals & (0x001 << 7)) === (0x001 << 7))
    SessionInfo.AppCfg.HasDelivery = true;
  else
    SessionInfo.AppCfg.HasDelivery = false;
  if ((ApplicationConfigurationVals & (0x001 << 4)) === (0x001 << 4))
    SessionInfo.AppCfg.HasTip = true;
  else
    SessionInfo.AppCfg.HasTip = false;
  if ((ApplicationConfigurationVals & (0x001 << 8)) === (0x001 << 8))
    SessionInfo.AppCfg.HasItemLookup = true;
  else
    SessionInfo.AppCfg.HasItemLookup = false;
  if ((ApplicationConfigurationVals & (0x001 << 9)) === (0x001 << 9))
    SessionInfo.AppCfg.HasRecipeLookup = true;
  else
    SessionInfo.AppCfg.HasRecipeLookup = false;
  if ((ApplicationConfigurationVals & (0x001 << 10)) === (0x001 << 10))
    SessionInfo.AppCfg.HasStorePromotion = true;
  else
    SessionInfo.AppCfg.HasStorePromotion = false;
  if ((ApplicationConfigurationVals & (0x001 << 11)) === (0x001 << 11))
    SessionInfo.AppCfg.HasAccountInfo = true;
  else
    SessionInfo.AppCfg.HasAccountInfo = false;
  if ((ApplicationConfigurationVals & (0x001 << 12)) === (0x001 << 12))
    SessionInfo.AppCfg.HasGiftCards = true;
  else
    SessionInfo.AppCfg.HasGiftCards = false;
  if ((ApplicationConfigurationVals & (0x001 << 13)) === (0x001 << 13))
    SessionInfo.AppCfg.HasCoupons = true;
  else
    SessionInfo.AppCfg.HasCoupons = false;
  if ((ApplicationConfigurationVals & (0x001 << 14)) === (0x001 << 14))
    SessionInfo.AppCfg.HasShoppingList = true;
  else
    SessionInfo.AppCfg.HasShoppingList = false;
  if ((ApplicationConfigurationVals & (0x001 << 15)) === (0x001 << 15))
    SessionInfo.AppCfg.CategoryPage = true;
  else
    SessionInfo.AppCfg.CategoryPage = false;
  if ((ApplicationConfigurationVals & (0x001 << 16)) === (0x001 << 16))
    SessionInfo.AppCfg.HasPartialPayment = true;
  else
    SessionInfo.AppCfg.HasPartialPayment = false;
  SessionInfo.AllowPartial = SessionInfo.AppCfg.HasPartialPayment;
  if ((ApplicationConfigurationVals & (0x001 << 17)) === (0x001 << 17))
    SessionInfo.AppCfg.HasSeats = true;
  else
    SessionInfo.AppCfg.HasSeats = false;
  if ((ApplicationConfigurationVals & (0x001 << 18)) === (0x001 << 18))
    SessionInfo.AppCfg.HasGuestInvite = true;
  else
    SessionInfo.AppCfg.HasGuestInvite = false;
  if ((ApplicationConfigurationVals & (0x001 << 19)) === (0x001 << 19))
    SessionInfo.AppCfg.HasDiscounts = true;
  else
    SessionInfo.AppCfg.HasDiscounts = false;
  if ((ApplicationConfigurationVals & (0x001 << 20)) === (0x001 << 20))
    SessionInfo.AppCfg.HasCredit = true;
  else
    SessionInfo.AppCfg.HasCredit = false;
  if ((ApplicationConfigurationVals & (0x001 << 22)) === (0x001 << 22))
    SessionInfo.AppCfg.HasReturns = true;
  else
    SessionInfo.AppCfg.HasReturns = false;
  if ((ApplicationConfigurationVals & (0x001 << 24)) === (0x001 << 24))
    SessionInfo.AppCfg.HasTax1 = true;
  else
    SessionInfo.AppCfg.HasTax1 = false;
  if ((ApplicationConfigurationVals & (0x001 << 25)) === (0x001 << 25))
    SessionInfo.AppCfg.HasTax2 = true;
  else
    SessionInfo.AppCfg.HasTax2 = false;
  if ((ApplicationConfigurationVals & (0x001 << 26)) === (0x001 << 26))
    SessionInfo.AppCfg.HasTax3 = true;
  else
    SessionInfo.AppCfg.HasTax3 = false;
  if ((ApplicationConfigurationVals & (0x001 << 27)) === (0x001 << 27))
    SessionInfo.AppCfg.HasWorkflow = true;
  else
    SessionInfo.AppCfg.HasWorkflow = false;
  if ((ApplicationConfigurationVals & (0x001 << 28)) === (0x001 << 28))
    SessionInfo.AppCfg.HasCashPayment = true;
  else
    SessionInfo.AppCfg.HasCashPayment = false;
  if ((ApplicationConfigurationVals & (0x001 << 29)) === (0x001 << 29))
    SessionInfo.AppCfg.HasVoidOrder = true;
  else
    SessionInfo.AppCfg.HasVoidOrder = false;
  if ((ApplicationConfigurationVals & (0x001 << 30)) === (0x001 << 30))
    SessionInfo.AppCfg.HasVoidItem = true;
  else
    SessionInfo.AppCfg.HasVoidItem = false;
  // Note - Hardcoded for now
  SessionInfo.AppCfg.HasGooglePay = true;
}
// Set State Variables for Encoded Bit-Values For LayoutConfiguration
// ** Add to getRecord  await this.setLayoutConfigurationBitEncoded(row[elem.n])
function setLayoutConfigurationBitEncoded(LayoutConfigurationVals) { // Note - Heavily Modified  
  trace(`Set LayoutConfiguration BitEncoded`);
  displayHex("==> Hex LayoutConfigurationVals",LayoutConfigurationVals);
  if ((LayoutConfigurationVals & ENLayoutCnfg.HasLandingPage) > 0 && SessionInfo.ApplicationTypeID > 1)
    SessionInfo.HasLandingPage = true;
  else
    SessionInfo.HasLandingPage = false;
  //if ((LayoutConfigurationVals & (0x001 << 1)) === (0x001 << 1))
  //  SessionInfo.HasLandingPage = true;
  //else
  //  SessionInfo.HasLandingPage = false;
  if ((LayoutConfigurationVals & ENLayoutCnfg.HasMenuImage) > 0 && SessionInfo.ApplicationTypeID > 3)
    SessionInfo.HasMenuImage = true; // Background Image for Order/Scan Screen
  else
    SessionInfo.HasMenuImage = false;
  if ((LayoutConfigurationVals & (0x001 << 2)) === (0x001 << 2))
    SessionInfo.HasLocationInfo = true;
  else
    SessionInfo.HasLocationInfo = false;
  if ((LayoutConfigurationVals & (0x001 << 3)) === (0x001 << 3))
    SessionInfo.HasBackgroundMenuImage = true;
  else
    SessionInfo.HasBackgroundMenuImage = false;
  // Choose the Menu Layout - 5 (8) Options
  SessionInfo.DefaultMenuLayout = 1;
  SessionInfo.MenuLayoutSelection = 1;
  if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout1) > 0) {
    SessionInfo.MenuLayoutSelection = 1;
    SessionInfo.DefaultMenuLayout = 1;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout2) > 0) {
    SessionInfo.MenuLayoutSelection = 2;
    SessionInfo.DefaultMenuLayout = 2;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout3) > 0) {
    SessionInfo.MenuLayoutSelection = 3;
    SessionInfo.DefaultMenuLayout = 3;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout4) > 0) {
    SessionInfo.MenuLayoutSelection = 4;
    SessionInfo.DefaultMenuLayout = 4;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout5) > 0) {
    SessionInfo.MenuLayoutSelection = 5;
    SessionInfo.DefaultMenuLayout = 5;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout6) > 0) {
    SessionInfo.MenuLayoutSelection = 6;
    SessionInfo.DefaultMenuLayout = 6;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout7) > 0) {
    SessionInfo.MenuLayoutSelection = 7;
    SessionInfo.DefaultMenuLayout = 7;
  } else if ((LayoutConfigurationVals & ENLayoutCnfg.UseMenuLayout8) > 0) {
    SessionInfo.MenuLayoutSelection = 8;
    SessionInfo.DefaultMenuLayout = 8;
  }
  else {
    SessionInfo.MenuLayoutSelection = 1;
    SessionInfo.DefaultMenuLayout = 1;
  }
  trace(`EntityConfig - Menu Select: ${SessionInfo.MenuLayoutSelection}, Default: ${SessionInfo.DefaultMenuLayout}`);
  if ((LayoutConfigurationVals & ENLayoutCnfg.HasGroupMenus) > 0)
    SessionInfo.HasGroupMenus = true;
  else
    SessionInfo.HasGroupMenus = false;
  if ((LayoutConfigurationVals & ENLayoutCnfg.RetailConfiguration) > 0)
    SessionInfo.RetailConfiguration = true;
  else
    SessionInfo.RetailConfiguration = false;
  if ((LayoutConfigurationVals & ENLayoutCnfg.CategoryImages) > 0) {
    SessionInfo.HasCategoryImages = true;
  } else {
    SessionInfo.HasCategoryImages = false;
  }
  //if ((LayoutConfigurationVals & (0x001 << 15)) === (0x001 << 15))
  //  SessionInfo.HasGroupMenus = true;
  //else
  //  SessionInfo.HasGroupMenus = false;
  //if ((LayoutConfigurationVals & (0x001 << 16)) === (0x001 << 16))
  //  SessionInfo.RetailConfiguration = true;
  //else
  //  SessionInfo.RetailConfiguration = false;

}
//-------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------
export async function GetCustomerInfo() {
  if (SessionInfo.PersonInfo.FirstName === undefined) {
    try {
      let CD = await CallOM("GetCustomerInfo",0,0,0); // Note - this is to get Customer Configuration Info
      trace(" Session data: " + JSON.stringify(SessionInfo.PersonInfo));
      if (CD && CD.d) {
        trace(`===> Customer data: ${JSON.stringify(CD.d)}`);
        let row = CD.d;
        CustomersO.forEach((elem) => {
          if (elem.n in row) {
            //trace(`Set ${elem.n}: ${row[elem.n]}`);
            try {
              if (elem.t === 34 || elem.t === 35) { // Date, DateTime
                //sobj[elem.n] = new Date(row[elem.n]); // For use with DateTime Control
                SessionInfo.PersonInfo[elem.n] = new Date(row[elem.n]);
              } else if (elem.t === 28) {
                SessionInfo.PersonInfo[elem.n] = row[elem.n];
              } else {
                SessionInfo.PersonInfo[elem.n] = row[elem.n];
              }
            }
            catch (error) {
              trace(`Set CustomersO Field: ${elem.n}, Error: ${error.message}`);
            }
          }
        });
        SessionInfo.SoundOn = SessionInfo.PersonInfo.SoundOn;
        //trace(`SoundON: ${SessionInfo.SoundOn} for UserID: ${SessionInfo.PersonInfo.CustomerID}`);
        SessionInfo.logonName = getDisplayName();
        SessionInfo.PersonPhotoID = SessionInfo.PersonInfo["PersonPhotoID"];
        if (SessionInfo.PersonInfo.RoleID === 279) { // Note Permission 279 is developer level
          trace(`----> RoleID: ${SessionInfo.PersonInfo.RoleID}, ${SessionInfo.RoleID}, Perm: ${SessionInfo.PermLevel}`);
          SessionInfo.FullName = SessionInfo.PersonInfo.FirstName + " " + SessionInfo.PersonInfo.LastName;
          SessionInfo.headerTitle = SessionInfo.FullName;
        } else {
          SessionInfo.FullName = SessionInfo.PersonInfo.FirstName + " " + SessionInfo.PersonInfo.LastName;
          SessionInfo.headerTitle = SessionInfo.FullName;
          //this.saveEmailAddress = SessionInfo.PersonInfo.EmailAddress;
          //let actv = this.state.CustomerControls & 0x00000002;
          //  this.setState({ accountActive: this.testBit(this.state.CustomerControls, 1) });
          //  this.setState({ accountHold: this.testBit(this.state.CustomerControls, 2) });
          //  this.setState({ accountHasCredit: this.testBit(this.state.CustomerControls, 5) });
          //  this.setState({ customerDirectPay: this.testBit(this.state.CustomerControls, 6) });
          //  this.setState({ customerWatch: this.testBit(this.state.CustomerControls, 7) });
        }
        await GetConfigInfo(); // Changed to await 10Mar25
      } else
        trace(`Unable to get customer data`);
    }
    catch (error) {
      trace(`*** Error - GetCustomerData: ${error.message}`);
    }
  } else {
    if (SessionInfo.logonName === "Temp")
      SessionInfo.logonName = getDisplayName();
    trace(`Customer Info - FirstName: ${SessionInfo.PersonInfo.FirstName}`);
  }
  //trace("Get Customer - photoID: " + SessionInfo.PersonPhotoID);
}
export async function GetConfigInfo() {
  //let imageID = 19;
  try {
    const startTime = performance.now();
    let CD = await CallOM("GetEntityConfigurationForEntity",0,0);
    let row = CD.d;
    //trace(`===> EntityCD: ${JSON.stringify(CD)}`);
    loadValues(row,EntityConfigurationO,ECV);
    if (ECV.ApplicationTypeID)
      SessionInfo.ApplicationTypeID = ECV.ApplicationTypeID;
    if (SessionInfo.ApplicationTypeID <= 0)
      SessionInfo.ApplicationTypeID = 1;
    trace(`===> ApplicationTypeID: ${SessionInfo.ApplicationTypeID}`);
    if (row.DefaultTableID)
      ECV.DefaultTableID = row.DefaultTableID;
    if (row.DefaultTableName)
      ECV.DefaultTableName = row.DefaultTableName;
    //trace(`===> EntityConfiguration: ${JSON.stringify(ECV)}`);
    SessionInfo.ECV = ECV;
    if (!SessionInfo.StoreLocationID || SessionInfo.StoreLocationID <= 1) {
      if (SessionInfo.StoreLocationID < 1 || SessionInfo.AppEntityID != 3000487)
        SessionInfo.StoreLocationID = ECV.DefaultStoreLocationID;
    }
    CD = await CallOM("GetLogoImage",0,0); // From Company record
    SessionInfo.LogoImageURL = imagePrep(CD.d.Item2);
    trace(`====> LogoImage: length: ${SessionInfo.LogoImageURL.length}, ApplicationTypeID: ${ECV.ApplicationTypeID}`);
    // Get the Background Image for the Menu
    let imageID = ECV.BackgroundImage;
    SessionInfo.BackgroundImageURL = await getImageFileFromServer(imageID,5);
    // ---- Setup CSS Variables ----  
    EntityConfigurationO.forEach((elem) => {
      try { // Set Color and Font Controls - FontType, FontSize, FontWht
        //trace(` Ent-elem: ${elem.n}, val: ${ECV[elem.n]}`);
        if (elem.n.indexOf("Color") >= 0)
          setColorVar(elem.n,ECV[elem.n]);
        else if (elem.n.indexOf("Font") >= 0)
          setFontInfo(elem.n,ECV[elem.n]);
      } catch (ex) {
        trace(`elem: ${JSON.stringify(elem)} - Err: ${ex}`);
      }
    })
    //SessionInfo.activeColor = ECV.ButtonTextColor; // Used for Menu 
    SessionInfo.activeColor = ECV.InputTextColor; // Used for Menu 
    SessionInfo.buttonColor = ECV.ButtonTextColor;
    SessionInfo.inputTextColor = ECV.InputTextColor;
    trace(`--> ListSection: ${ECV.ListSectionBGColor}`);
    document.documentElement.style.setProperty('--BrandLogo',ECV.BrandLogo);
    //document.documentElement.style.setProperty('--LandingBackgroundColor',ECV.InputBorderColor);
    document.documentElement.style.setProperty('--BrandColor',ECV.BrandColor);
    SessionInfo.addColor = ECV.BrandColor;
    // ---- Setup Configuration Controls ----
    //SessionInfo.AppCfg = ECV.ApplicationConfiguration;
    setApplicationConfigurationControls(ECV.ApplicationConfiguration);
    if (SessionInfo.traceDebug) {
      trace(`===> App TypeID: ${SessionInfo.ApplicationTypeID}, HasCash: ${ENAppCnfg.HasCashPayment}, & HasCash: ${SessionInfo.AppCfg.HasCashPayment}, HasVoid: ${SessionInfo.AppCfg.HasVoidOrder}`);
      trace(`App Config: ${JSON.stringify(SessionInfo.AppCfg)}`);
      displayHex("==> Hex AppCfg",ECV.ApplicationConfiguration);
    }
    setLayoutConfigurationBitEncoded(ECV.LayoutConfiguration);
    if (SessionInfo.RetailConfiguration === true) { // Based on Retail configuration - disallow restaurant controls
      SessionInfo.AC.HasOrderType = false;
      SessionInfo.AC.HasTable = false;
      SessionInfo.AC.HasGuest = false;
      SessionInfo.AC.HasViewSeats = false;
    }
    // Set Session AC Configuration based on ApplicationTypeID  
    setSessionAC();
    trace(`Interact - Menu Layout: ${SessionInfo.MenuLayoutSelection}, ScanPay: ${SessionInfo.AppCfg.ScanAndPay}, MenuImage: ${SessionInfo.HasMenuImage}, BGColor: ${ECV.ListBGColor}`);
    // Note - 6Aug24 - ItemBuyColor & ItemTotalColor are not set from Config
    setFontInfo("ItemBuyFontType",ECV["ItemNameFontType"]);
    let size = ECV["ItemNameFontSize"];
    if (SessionInfo.MenuLayoutSelection != 5 && size < 4)
      size += 1;
    setFontInfo("ItemBuyFontSize",size);
    setFontInfo("ItemBuyFontWht",ECV["ItemNameFontWht"]);
    trace(`---> Set CSS Vars Complete`);           
    // Table Setup
    if (SessionInfo.CurrentTableID <= 0) {
      SessionInfo.CurrentTableID = ECV.DefaultTableID;
      SessionInfo.CurrentTableName = ECV.DefaultTableName;
      let locInfo = { "SLoc": SessionInfo.StoreLocationID,"TabID": SessionInfo.CurrentTableID };
      if (SessionInfo.AppEntityID > 0)
        setCookie(`IM${SessionInfo.AppEntityID.toString()}Info`,JSON.stringify(locInfo),30);
      else
        setCookie(`IMInfo`,JSON.stringify(locInfo),30);
    }
    // ---- Set Colors ----
    let rgb = hexToRgb(ECV.ListBGColor); // 'rgba(240, 240, 240, 0.75)';
    //trace(`rgb: ${JSON.stringify(rgb)}`);
    if (SessionInfo.HasMenuImage === true)
      SessionInfo.orderBGColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.o})`
    else
      SessionInfo.orderBGColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.o})`
    trace(`orderBG: ${SessionInfo.orderBGColor}`);
    // ---- appMain Setup - Set Location and Table ----
    await SessionInfo.AppMainRef.appMainSetup();
    // ---- Call Menu Setup ----
    SessionInfo.AppMainRef.SetupMenu();
    const endTime = performance.now();
    const executionTime = Math.round(endTime - startTime);
    console.log(`===> GetConfigInfo execution time: ${executionTime} milliseconds`);
    trace(`===> ApplicationTypeID: ${SessionInfo.ApplicationTypeID}`);
  }
  catch (error) {
    trace(`*** Error - GetEntityConfiguration: ${error.message}`,5);
  }
}
export async function GetLocationInfo(storeLocationID,tableID) {
  try {
    let CD = await CallOM("GetStoreInfo",tableID,storeLocationID);
    trace(`====> Get StoreLocation: ${storeLocationID} - CD: ${JSON.stringify(CD)}`);
    SessionInfo.GeoLocation = CD.d.GeoLocation;
    //trace(`GetLocationInfo - geolocation: ${SessionInfo.GeoLocation}, location: ${storeLocationID}, tableID: ${tableID}`);
    loadValues(CD.d,StoreLocationsO,SLV);
    SessionInfo.StoreLocationID = storeLocationID;
    SessionInfo.StoreName = SLV.StoreName;
    trace(`===> StoreLocation: ${JSON.stringify(SLV)}`);
  } catch (ex) {
    console.log(`*** Error in GetLocationInfo: storeLocation: ${storeLocationID}, tableID: ${tableID}, error: ${ex}`);
  }
  SessionInfo.SLV = SLV;
}
export function loadValues(row,recDefinition,valDict) { // Note - only setting valDict => SLV
  recDefinition.forEach((elem) => {
    if (elem.n in row) {
      try {
        if (elem.t === 34 || elem.t === 35) { // Date, DateTime
          valDict[elem.n] = new Date(row[elem.n]);
        } else if (elem.t === 21 || elem.t === 195 || elem.t === 201) { // String, FK-Translated, Enum
          valDict[elem.n] = row[elem.n];
        } else if (elem.t === 28) { // Money
          valDict[elem.n] = row[elem.n];
        } else if (elem.t === 22) { // Boolean
          valDict[elem.n] = row[elem.n];
        } else if (elem.t === 41) { // Media - Image or Document
          valDict[elem.n] = row[elem.n];
        } else if (elem.t === 15) { // Encoded
          valDict[elem.n] = row[elem.n];
        } else {
          valDict[elem.n] = row[elem.n];
        }
        //trace(`Set valDict Field: ${elem.n}, Value: ${row[elem.n]}`);
      }
      catch (error) {
        trace(`Error - Set valDict Field: ${elem.n}, Error: ${error.message}`,5);
      }
    }
  });
}
export function setColorVar(name,colorVal) {
  let cssVar = '--' + name;
  //trace(`set color: ${name}, css: ${cssVar}, value: ${colorVal}`);
  try {
    document.documentElement.style.setProperty(cssVar,colorVal.trim());
  } catch (ex) {
    console.log(`Error: ${ex} in setColorVar - name: ${name}, val: ${colorVal}`);
  }
}
export function setFontInfo(fieldName,key) {
  let cssVar = "--" + fieldName;
  if (key <= 0)
    key = 1;
  if (fieldName.indexOf("Type") >= 0)
    document.documentElement.style.setProperty(cssVar,FontTypeValues[key - 1].n);
  else if (fieldName.indexOf("Size") >= 0) {
    document.documentElement.style.setProperty(cssVar,FontSizeValues[key - 1].n);
    if (fieldName === "SectionFontSize")
      document.documentElement.style.setProperty("--SectionHeadFontSize",FontSizeValues[key + 1].n);
    else if (fieldName === "HeadFontSize")
      document.documentElement.style.setProperty("--HeadFontNameSize",FontSizeValues[key + 1].n);
  }
  else // Wht
    document.documentElement.style.setProperty(cssVar,FontWhtValues[key - 1].n);
}
//-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export function calcGeoDistance(lat1,lon1,lat2,lon2) {
  let R = 6371; // km
  let dLat = toRad(lat2 - lat1);
  let dLon = toRad(lon2 - lon1);
  lat1 = toRad(lat1);
  lat2 = toRad(lat2);

  let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  let c = 2 * Math.atan2(Math.sqrt(a),Math.sqrt(1 - a));
  let d = R * c;
  return d;
}
// Converts numeric degrees to radians
function toRad(Value) {
  return Value * Math.PI / 180;
}
//-------------------------------------------------------------------------------------------------------------
export function setCookie(cName,cValue,expDays) { // writecookie, savecookie
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  //const expires = "" + date.toUTCString();
  trace(`==> setCookie - ${cName}=${cValue} expires=${date.toUTCString()} SessionInfo.defaultLogon=${SessionInfo.defaultLogon}  secure; samesite=strict; path=/`);
  if (SessionInfo.defaultLogon === false) // Don't save cookie for logon (and ALL cookies) if default logon
    document.cookie = `${cName}=${cValue}; expires=${date.toUTCString()}; secure; samesite=strict; path=/`;
}
export function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); // to be sure it is not encoded
  const cArr = cDecoded.split('; ');
  let cValue;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) cValue = val.substring(name.length);
  })
  trace(`==> getCookie - ${cName}=${cValue}`);
  return cValue;
}
export function deleteCookie(cName) { // removecookie
  trace(`Delete Cookie: ${cName}`);
  document.cookie = `${cName}=x; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}
//-------------------------------------------------------------------------------------------------------------
export function loadScript(url,callback) {
  trace(`loadScript`);
  let script = document.createElement("script")
  script.type = "text/javascript";

  //if (script.readyState) {  //IE
  //  script.onreadystatechange = function () {
  //    if (script.readyState == "loaded" ||
  //      script.readyState == "complete") {
  //      script.onreadystatechange = null;
  //      callback();
  //    }
  //  };
  //} else {  //Others
  script.onload = function () {
    callback();
  };
  //}

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}
export const appendScript = (scriptToAppend) => {
  const script = document.createElement("script");
  script.src = scriptToAppend;
  script.async = true;
  document.body.appendChild(script);
}
export const removeScript = (scriptToremove) => {
  let allsuspects = document.getElementsByTagName("script");
  for (let i = allsuspects.length; i >= 0; i--) {
    if (allsuspects[i] && allsuspects[i].getAttribute("src") !== null
      && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`) !== -1) {
      allsuspects[i].parentNode.removeChild(allsuspects[i])
    }
  }
}
export function useScript() {
  trace(`useScript`);
  InitScriptX();
}
//-------------------------------------------------------------------------------------------------------------
export async function AddressLogOn() {
  console.log("Address Log On");
}
export function testBit(controls,bitPos) {
  let testBit = 0x01 << bitPos;
  let actv = controls & testBit;
  //trace(`bitPos: ${bitPos}, actv: ${actv}`);
  return actv;
}
export function saveBit(control,bitPos) {
  let testBit = 0x01 << bitPos;
  //trace(`bitPos: ${bitPos}, testBit: ${testBit}`);
  if (control === true)
    return testBit;
  else
    return 0;
}
//---------------------------------------------------------------------------------------------
export const GoogleAuthProvider = ({ children }) => {
  const googleAuth = useGoogleLogin({
    clientId: process.env.GOOGLE_CLIENT_ID, // Your clientID from Google.
  })

  return (
    <GoogleAuthContext.Provider value={googleAuth}>
      {children}
    </GoogleAuthContext.Provider>
  )
}
export const useGoogleAuth = () => React.useContext(GoogleAuthContext);

export const LogoutButton = () => {
  const { signOut } = useGoogleAuth();

  return (
    <button onClick={signOut}>Logout</button>
  );
};

export async function UserRegister(firstName,lastName,email,phoneNumber,password,confirmPassword,regCode,imageURL,regType) {
  if (password !== confirmPassword) {
    trace(`password issue - password: ${password}, confirm: ${confirmPassword}`)
    return ("pa")
  }
  let token = '';
  let timeAdj = new Date().getTimezoneOffset();
  if (SessionInfo.debug === true)
    timeAdj = 0;
  let TimeAdj = timeAdj.toString();
  let extendedID = "";
  if (regType === "GOOG") {
    extendedID = phoneNumber;
    phoneNumber = "";
  }
  let ldata = { FirstName: firstName,LastName: lastName,UserName: email,PhoneNumber: phoneNumber,Password: password,ConfirmPassword: confirmPassword,Token: token,Image: imageURL,AppProductID: SessionInfo.AppProductID.toString(),AppSiteID: SessionInfo.AppSiteID.toString(),AppEntityID: SessionInfo.AppEntityID.toString(),RegistrationCode: regCode,DomainName: SessionInfo.host,RegType: regType,TimeAdjust: TimeAdj,ExtendedID: extendedID };
  if (SessionInfo.session === undefined)
    SessionInfo.session = 0;
  trace(` Register ldata: ${JSON.stringify(ldata)}`);
  const CD = await accessOMAPI(103,0,0,0,ldata);
  if (!CD)
    return "fail";
  trace(` UserRegister return CD: ${JSON.stringify(CD)}`);
  if (CD.x.o < 9500) { // Successful logon
    SessionInfo.session = CD.x.s;
    SessionInfo.AppEntityID = CD.x.t;
    SessionInfo.OMUserID = CD.x.k;
    SessionInfo.logonType = 3;  // 1-logon, 3-Register, 4-token logon, 5-Google Logon, 9-default logon
    SessionInfo.defaultLogon = false;
    if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
      if (SessionInfo.sequenceid > 100) // 1 Indicates Initial response after signon
        console.log(`***> Bad Return Sequence (5) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
    }
    SessionInfo.sequenceid = CD.x.q;
    let ret = await SetConfigInfo(CD.d,email); // Data returned from register (103)
    return ret;
  }
  else
    return CD.x.m;
}
export async function CallConfirmation(AppProductID,ConfirmationKey) { // 9Nov23 - not used yet - used to confirm registration
  console.log(` Confirmation Key: ${JSON.stringify(ConfirmationKey)}`);
  try {
    const CD = await accessOMAPI(108,2,AppProductID,1,ConfirmationKey);
    console.log("Register Confirmation CD: " + JSON.stringify(CD));
    if (CD.x.o < 9500) { // Successful Confirmation
      SessionInfo.session = CD.x.s;
      if (SessionInfo.sequenceid + 1 != CD.x.q) { // Report a problem
        if (SessionInfo.sequenceid > 100) // 1 Indicates Initial response after signon
          console.log(`***> Bad Return Sequence (6) ${CD.x.q}, Current Sequence: ${SessionInfo.sequenceid}`);
      }
      SessionInfo.sequenceid = CD.x.q;
      SessionInfo.logonName = "";
      SessionInfo.OMUserID = CD.x.k;
      SessionInfo.logonEmailAddress = "";
      SessionInfo.commErrorCount = 0;
      console.log("Confirmation ID: " + CD.x.s + " set: " + SessionInfo.session);
      return "ok";
    }
    else
      return CD.x.m;
  }
  catch (ex) {
    console.log(`Confirmation exception: ${ex}`,5);
  }
}
export async function CheckPermission(bit) { // Check if User has a particular permission bit
  const CD = await accessOMAPI(51,0,0,bit);
  if (!CD) {
    if (CD.x.p === 1)
      return true;
  }
  return false;
}
export async function QueryPing() { // Ping Server
  if (SessionInfo.session && SessionInfo.loggedOn === true) {
    const CD = await accessOMAPI(61,0,0,0,"0|0"); // Lat|Long
    if (CD) {
      if (CD.x.p === 1)
        return true;
      else
        console.log("Query Ping Failed = p=" + CD.x.p);
    }
  }
  return false;
}
export async function LogOff(removeToken) { // remove cookie Token - true/false
  if (SessionInfo.loggedOn === true) {
    try {
      SessionInfo.loggedOn = false;
      SessionInfo.message = ""; // This will clear the messages in the Header message display - Header copies this value into the Display Box
      trace(`Logoff - remove Token: ${removeToken} - ${SessionInfo.logonName} - Signed Out`);
      if (SessionInfo.InLogoff === false) {
        SessionInfo.InLogoff = true;
        await accessOMAPI(102,0,0,0); // OM Logoff
      }
      trace("Clear Session in Logoff - set errorCount to 0");
      SessionInfo.session = '';
      SessionInfo.sequenceid = 100001;
      SessionInfo.ResetOrder = false; // Note - 17May23 - this WAS true
      // Logged In Information  
      SessionInfo.logonName = '';
      SessionInfo.OMUserID = 0;
      SessionInfo.AppEntityID = 0; // Added 24Jan25 - this is overriding DomainName in logon when set
      SessionInfo.logonEmailAddress = '';
      SessionInfo.loggedOn = false;
      SessionInfo.FullName = '';
      SessionInfo.notifyMessage = '';
      SessionInfo.flagLevel = 0;
      SessionInfo.currentPage = '';
      // Control Information     
      SessionInfo.notifyMessage = "";
      SessionInfo.flagLevel = 0;
      SessionInfo.refreshCustomerProfile = true;
      SessionInfo.registerCounter = 0;
      // Functions
      SessionInfo.currentPage = '';
      // Page Session Info                   
      SessionInfo.CustomerProfile = undefined;
      SessionInfo.StoreLocations = undefined;
      //SessionInfo.StoreLocationDetail = undefined;
      SessionInfo.SettingsPage = undefined;
      SessionInfo.AppMainPage = undefined;
      SessionInfo.StoreLocationDetail = undefined;
      SessionInfo.StoreItemDetail = undefined;
      SessionInfo.CustomerProfile = undefined;
      SessionInfo.SettingsPage = undefined;
      SessionInfo.ManagerPage = undefined;
      SessionInfo.gotoAutoPage = '';
      // Key Information
      SessionInfo.SelectLocationID = 0;
      if (removeToken === undefined || removeToken === true) {
        removeToken = true;
        if (SessionInfo.EntCookie === true)
          deleteCookie(`IMSecure${+SessionInfo.AppEntityID.toString()}ID`); // Delete the Menu logon token
        else
          deleteCookie(`IMSecureID`); // Delete the Menu logon token 
        SessionInfo.phoneLoginVerify = false;
      } 
      SessionInfo.phoneLoginVerify = true; // Default back to Phone Login
      SessionInfo.isPhoneLogon = true;
      SessionInfo.PersonInfo = {
        // Customer Info
        CustomerID: 0,
        FirstName: undefined,
        AdditionalName: '',
        LastName: '',
        Address: '',
        City: '',
        ProvinceStateID: 0,
        CountryID: 0,
        PostalCode: '',
        DateOfBirth: undefined,
        Gender: '',
        PhoneNumber: '',
        PhoneNumber2: '',
        EmailAddress: '',
        EmailReceipts: false,
        EmailPromotions: false,
        SMSReminders: false,
        SoundOn: false,
        PersonPhotoID: 0,
        RoleID: 0,
        TotalPurchaseAmount: 0,
        MaximumPurchaseAmount: 0,
        TodayPurchaseAmount: 0,
        LastTimeActive: undefined,
      };
      SessionInfo.logonToken = undefined;
      trace(`Session Cleared in Logoff - removeToken: ${removeToken}, AppEntityID: ${SessionInfo.AppEntityID}`);
    } catch (ex) {
      trace(`Failure in Logoff - ex: ${ex}`);
    }
    SessionInfo.InLogoff = false;
    trace(`Complete Logoff: phoneLoginVerify: ${SessionInfo.phoneLoginVerify}, isPhoneLogon: ${SessionInfo.isPhoneLogon}`);
  }
}
// Log off, logoff, sign out, sign off, signoff, force logoff, force sign off, 
export async function LogOffReset(msg,startType) {
  if (SessionInfo.loggedOn === true) { // Was logged on - assume timeout or error of some sort - see if cookie is still valid and logon again if so
    let keyValue = '';
    if (SessionInfo.EntCookie === true)
      keyValue = getCookie(`IMSecure${SessionInfo.AppEntityID.toString()}ID`);
    else
      keyValue = getCookie(`IMSecureID`);
    console.log(`cookie keyValue: ${keyValue}`);
    if (keyValue && keyValue !== 'NF') { // OM returned NF token
      //trace(`IMSecureID cookie: ${value}, RoleID: ${SessionInfo.RoleID}`);
      SessionInfo.loggedOn = true;
      SessionInfo.stayLoggedOn = true;
      SessionInfo.CheckoutToken = keyValue;
      await mainLogon(keyValue);
    } else {
      trace(`Logoff Reset: ${msg}`);
      await LogOff(false);
      SessionInfo.loggedOn = false;
    }
  }
  if (SessionInfo.loggedOn === false) {
    SessionInfo.forceLogoff = true;
    if (SessionInfo.props)
      SessionInfo.props.navigate("/Login");
  }
  else
    SessionInfo.props.navigate("/LandingPage");
}
export async function LogOffResetMsg(message,lfType) {
  if (SessionInfo.loggedOn === true) {
    trace(`LogOffReset Msg: ${message}`);
    displayWarning(message); //  22Apr25
    await LogOffReset(message,lfType);
  }
}
export async function TestREST() {
  console.log("Test REST API");
  const CD = await accessOMAPI(70,0,0,0);
  if (!CD)
    console.log("Unable to get CD");
  else
    console.log("CD Returned: " + JSON.stringify(CD));
}
export async function addContactInfo(item) {
  let PKID = 0;
  try {
    const CD = await accessOMAPI(201,0,544162,0,item);
    //trace("addContactInfo - CD: " + JSON.stringify(CD));
    item["QuestionID"] = CD.d.PKID;
    PKID = CD.d.PKID;
  } catch (error) {
    reportError(1,`addContactInfo Error: ${error.message}`);
  }
  return PKID;
}
export async function GetTableValues(tableID,keyName,key,fieldNames) { // Note: Assign CD.d.rows to the table data          
  return await accessOMAPI(21,0,tableID,key,fieldNames,keyName);
}
export async function GetTableData(tableID,fieldNames) { // Note: Assign CD.d.rows to the table data  
  let CD;
  try {
    CD = await accessOMAPI(1,0,tableID,0,undefined,'',fieldNames);
    //if (SessionInfo.debug === true)
    //  console.log("--> return TableData (" + tableID + "): " + JSON.stringify(CD));
  } catch (error) {
    reportError(1,"GetTableData Error: " + error.message);
  }
  return CD;
}
export async function GetTableDataRaw(tableID) { // Note: Assign CD.d.rows to the table data 
  let CD;
  try {
    CD = await accessOMAPI(1,1,tableID,0);
    //if (SessionInfo.debug === true)
    //  console.log("--> return TableDataRaw (" + tableID + "): " + JSON.stringify(CD));
  } catch (error) {
    reportError(1,"GetTableDataRaw Error: " + error.message);
  }
  return CD;
}
export async function GetTableFilter(tableID,filterCond) { // Note: Assign CD.d.rows to the table data
  //trace("GetTableFilter: " + tableID + " - filterCond: " + filterCond);           
  let CD;
  try {
    CD = await accessOMAPI(3,0,tableID,0,filterCond);
    //if (SessionInfo.debug === true)
    //  console.log("--> return TableFilter (" + tableID + "): " + JSON.stringify(CD));
  } catch (error) {
    reportError(1,"GetTableFilter Error: " + error.message);
  }
  return CD;
}
export async function GetTableSearch(tableID,searchCond,callParm) { // Note: Assign CD.d.rows to the table data
  if (!searchCond)
    searchCond = '';
  else if (searchCond[0] !== "*")
    searchCond = "`" + searchCond;  // ` related search - search attached tables   
  if (SessionInfo.debug === true)
    console.log(`--> TableSearch: ${JSON.stringify(searchCond)}`);
  let CD;
  try {
    if (callParm) {
      //export default async function accessOMAPI(operation, control, tableID, key, rdata, modexMethod, optionColumns, callParm, pageID) {
      CD = await accessOMAPI(4,2,tableID,0,searchCond,undefined,undefined,callParm); // Translate according to callParm 
    }
    else {
      CD = await accessOMAPI(4,2,tableID,0,searchCond); // Translate All values (2) 
    }
    //if (SessionInfo.debug === true)
    //  console.log("--> return TableSearch (" + tableID + "): " + JSON.stringify(CD));
  } catch (error) {
    reportError(1,"GetTableSearch Error: " + error.message);
  }
  return CD;
}
export async function GetTableSearchRaw(tableID,searchCond,columns,isSub) { // GetTableSearch in Mdx - Note: Assign CD.d.rows to the table data  Note: Can use: *DISP, *DSPO, *EDIT, *EDTO in place of column names
  if (!searchCond)
    searchCond = '';
  else if (searchCond[0] !== "*" && isSub)
    searchCond = "`" + searchCond;
  if (SessionInfo.debug === true)
    console.log(`--> TableSearchRaw: ${JSON.stringify(searchCond)}`);
  const CD = await accessOMAPI(4,1,tableID,0,searchCond,'',columns); // NOTranslate values - For Edit Grid 
  //if (SessionInfo.debug === true)
  //  console.log("--> return TableSearchRaw (" + tableID + "): " + JSON.stringify(CD));
  return CD;
}
export async function DeleteRowTry(tableID,key) { // DeleteTableRow
  let CD;
  try {
    trace(`DeleteRow table: ${tableID}, key: ${key}`);
    CD = await accessOMAPI(401,0,tableID,key);
    console.log("DeleteRow post CD: " + JSON.stringify(CD));
  } catch (error) {
    reportError(1,"Delete Row Error: " + error.message);
  }
  return CD;
}
export async function DeleteRowForce(tableID,key) { // DeleteTableRow
  let CD;
  try {
    trace(`DeleteRowForce table: ${tableID}, key: ${key}`);
    CD = await accessOMAPI(402,0,tableID,key);
    console.log(`DeleteRow post CD: ${JSON.stringify(CD)}`);
  } catch (error) {
    reportError(1,"Delete Row Force Error: " + error.message);
  }
  return CD;
}
//------------------ Support Access ------------------
export async function GetDropdownData(tableID) {
  let CD;
  try {
    CD = await accessOMAPI(11,0,tableID,1);
    if (CD.d === undefined || CD.d === null)
      CD.d = [{ ddName: '',ddID: 0 }];
  } catch (error) {
    reportError(1,"Get Dropdown Info: " + error.message);
  }
  return CD;
}
export async function GetDependentDropdownData(tableID,key,dependentOnObjectID) {
  let CD;
  try {
    //trace("Get Dependent Dropdown table: " + tableID + " Key: " + key);
    CD = await accessOMAPI(13,0,tableID,key,dependentOnObjectID);
    if (CD.d === undefined || CD.d === null)
      CD.d = [{ ddName: '',ddID: 0 }];
  } catch (error) {
    reportError(1,"Get Dependent Dropdown Info: " + error.message);
  }
  return CD;
}
// Create a Key Pair
export async function CreateKeys() { // Create Key Pair
  let pair = keypair(512); //3072); Key Pair Library
  let PublicKey = pair["public"];
  PublicKey = PublicKey.substring(31,132);
  this.setState({ PublicKey });
  let PrivateKey = pair["private"];
  PrivateKey = PrivateKey.substring(32);
  PrivateKey = PrivateKey.substring(0,PrivateKey.length - 31);
  await this.setState({ PrivateKey });
  await this.saveRecord();
}
//--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

export async function CallOM(modexMethod,tableID,key,parmControl1,rdata,columns,callParm,pageID) { // Note - parmControl1 MUST be set if rdata is specified - see OMProxy - note: callParm corresponds to ActiveParm2
  //case 0: None - Supports Column Specification
  //case 1: // Int
  //case 2: // String
  //case 3: // Decimal
  //case 4: // Double
  //case 5: // DateTime
  //case 10: // List of Object Values
  //case 11: // List of int Values
  //case 12: // List of string Values
  //case 13: // Dictionary of name-object Values
  //case 14: // Dictionary of name-string Values
  //case 15: // List of Dictionary of name-string Values
  //case 16: // Int Array
  //case 17: // String Array
  //case 18; // Byte Array
  //case 19: // Byte Tuple
  //case 20: // Byte Tuple
  //case 21: // WorkTaskS
  //case 50: // Type Parameter Array
  // Note - callParm corresponds to ActiveParm2
  //      - control corresponds to ActiveParm1 - but is used to control the type of parameter in rdata
  // Note - columns - array of strings - if integer is passed convert to string
  if (rdata === undefined || rdata === null)
    rdata = '';  
  if (callParm === undefined || callParm === null)
    callParm = '';
  if (parmControl1 === undefined || parmControl1 === null)
    parmControl1 = 0; 
  else if (parmControl1 === 0) { // No parameters passed to OM function
    //trace(`ERROR: parm control is 0 - rdata: ${rdata}`);
    rdata = '';
    //parmControl1 = 2; // String
  }
  if (SessionInfo.debug && SessionInfo.traceDebug) {
    if (SessionInfo.BlockTrace === "" || SessionInfo.BlockTrace.indexOf(modexMethod) < 0) {
      if (columns) {
        if (rdata.length > 200)
          trace(`CALLOM method: ${modexMethod}, tableID: ${tableID}, key: ${key}, parmControl1: ${parmControl1}, rdata-lth: ${rdata.length}, typeof: ${typeof (rdata)}, columns: ${columns}, Parm: ${callParm}, page: ${pageID}`);
        else
          trace(`CALLOM method: ${modexMethod},tableID: ${tableID}, key: ${key}, parmControl1: ${parmControl1}, rdata: ${rdata}, typeof: ${typeof (rdata)}, columns: ${columns}, Parm: ${callParm},page: ${pageID}`);
      } else {
        if (rdata.length > 200)
          trace(`CALLOM method: ${modexMethod}, tableID: ${tableID}, key: ${key}, parmControl1: ${parmControl1}, rdata-lth: ${rdata.length}, typeof: ${typeof (rdata)}, parm2: ${callParm}`);
        else
          trace(`CALLOM method: ${modexMethod}, tableID: ${tableID}, key: ${key}, parmControl1: ${parmControl1}, rdata: ${rdata}, typeof: ${typeof (rdata)}, parm2: ${callParm} `);
      }
    }
  }
  //trace("CallOM callParm: " + callParm);
  modexMethod = "CheckoutMdx_" + modexMethod;
  return await accessOMAPI(291,parmControl1,tableID,key,rdata,modexMethod,columns,callParm,pageID);
}
export async function CallOMP(modexMethod,rdata1,rdata2,rdata3,rdata4,rdata5,rdata6,rdata7,rdata8,rdata9) {
  let control = 9; // List of parameter values
  let tableID = 0;
  let key = 0;
  let parms = [];
  //trace(`CallOMP - rdata1: ${rdata1}, rdata2: ${rdata2}, rdata3: ${rdata3}`);
  if (rdata1 !== undefined)
    parms.push(rdata1);
  if (rdata2 !== undefined)
    parms.push(rdata2);
  if (rdata3 !== undefined)
    parms.push(rdata3);
  if (rdata4 !== undefined)
    parms.push(rdata4);
  if (rdata5 !== undefined)
    parms.push(rdata5);
  if (rdata6 !== undefined)
    parms.push(rdata6);
  if (rdata7 !== undefined)
    parms.push(rdata7);
  if (rdata8 !== undefined)
    parms.push(rdata8);
  if (rdata9 !== undefined)
    parms.push(rdata9);
  modexMethod = "CheckoutMdx_" + modexMethod;
  trace(`CallOMP - Debug - cnt: ${parms.length}, MM: ${modexMethod}, parms: ${JSON.stringify(parms)}`);
  return await accessOMAPI(291,control,tableID,key,parms,modexMethod,"",9);
}
// Call Parameter Type
export const CTYP = { NONE: 0,INT: 1,STR: 2,DEC: 3,DBL: 4,DATE: 5,BOOL: 6,LONG: 7,LSTOV: 10,LSTIV: 11,LSTSV: 12,DICTNO: 13,DICTNS: 14,LSTDICTNS: 15,INTA: 16,STRA: 17,BYTA: 18,BT: 19,IMGO: 20,BOOLA: 21,WTSK: 31,TypParm: 50 }
//case 0: None - Supports Column Specification
//case 1: // Int
//case 2: // String
//case 3: // Decimal   
//case 4: // Double
//case 5: // DateTime
//case 10: // List of Object Values
//case 11: // List of int Values
//case 12: // List of string Values
//case 13: // Dictionary of name-object Values
//case 14: // Dictionary of name-string Values
//case 15: // List of Dictionary of name-string Values
//case 16: // Int Array
//case 17: // String Array
//case 18; // Byte Array
//case 19: // Byte Tuple
//case 20: // Image Object
//case 21: // Bool Array
//case 31: // WorkTaskS
//case 50: // Type Parameter Array
// Parameter Type
export const TYP = { INT: 1,STR: 2,DEC: 3,DBL: 4,DT: 5,BL: 6,IAR: 8 }; // Note - use TYP with OMT - NOT CTYP
// Note - if one of the rdataN values is undefined - that will be the end of the parameter list
export async function CallOMT(modexMethod,typ1,rdata1,typ2,rdata2,typ3,rdata3,typ4,rdata4,typ5,rdata5,typ6,rdata6,typ7,rdata7,typ8,rdata8,typ9,rdata9) {
  let control = 50; // List of type/parameter pairs 1-int, 2-string, 3-decimal, 4-double, 5-datetime, 6-bool, 8-integer array
  let tableID = 0;
  let key = 0;
  let parms = [];
  if (SessionInfo.debug)
    console.log(`CallOMT - method: ${modexMethod} rdata1: ${rdata1}, rdata2: ${rdata2}, rdata3: ${rdata3}`);
  if (rdata1 !== undefined) {
    parms.push(typ1);
    parms.push(rdata1);
  }
  if (rdata2 !== undefined) {
    parms.push(typ2);
    parms.push(rdata2);
    if (rdata3 !== undefined) {
      parms.push(typ3);
      parms.push(rdata3);
      if (rdata4 !== undefined) {
        parms.push(typ4);
        parms.push(rdata4);
        if (rdata5 !== undefined) {
          parms.push(typ5);
          parms.push(rdata5);
          if (rdata6 !== undefined) {
            parms.push(typ6);
            parms.push(rdata6);
            if (rdata7 !== undefined) {
              parms.push(typ7);
              parms.push(rdata7);
              if (rdata8 !== undefined) {
                parms.push(typ8);
                parms.push(rdata8);
                if (rdata9 !== undefined) {
                  parms.push(typ9);
                  parms.push(rdata9);
                }
              }
            }
          }
        }
      }
    }
  }
  modexMethod = "CheckoutMdx_" + modexMethod;
  //if (SessionInfo.debug)
  //  console.log(`CallOMT - cnt: ${parms.length}, MM: ${modexMethod}, parms: ${JSON.stringify(parms)}`);
  return await accessOMAPI(291,control,tableID,key,parms,modexMethod,"",50);
}
export async function getImageFileFromServer(imageID,size) {
  // image size: 1-Tiny, 2-Small, 3-Medium, 4-Large, 5-Fill Size
  console.log(`getImageFileFromServer ID: ${imageID}, size: ${size}`);
  if (!imageID || imageID <= 0) {
    return imagePrep(BlankImage);
  }
  if (!size)
    size = 0;
  if (SessionInfo.ImageStore.has(imageID) == true) {
    //console.log(`getImageFileFromServer - Image found in store: ${imageID}`);
    //console.log(`  URL: ${SessionInfo.ImageStore.get(imageID)}`);
    if (SessionInfo.ImageStore.has(imageID))
      return SessionInfo.ImageStore.get(imageID);
  }
  else {
    let CD = await CallOM("GetImage",0,imageID,0,'','',size,10); // 10 is pageid?
    //trace(`GetImage CD: ${JSON.stringify(CD)}`);
    let imageRep = imagePrep(CD.d.Item2);
    console.log(`getImageFileFromServer - Image retrieved from server: ${imageID}, imageRep: ${imageRep}, count: ${SessionInfo.ImageStore.length}`);
    SessionInfo.ImageStore.set(imageID, imageRep);
    return imageRep;
  }
}
export async function getImageFileFromAnyEnt(imageID,size) {
  // image size: 1-Tiny, 2-Small, 3-Medium, 4-Large, 5-Fill Size
  //trace(`getImageFileFromServer ID: ${imageID}, size: ${size}`);
  if (!imageID || imageID <= 0) {
    return imagePrep(BlankImage);
  }
  if (!size)
    size = 0;
  //trace(`GetImage CD: ${JSON.stringify(CD)}`);  
  if (SessionInfo.ImageStore.has(imageID) == true) {
    //console.log(`getImageFileFromServerEnt - Image found in store: ${imageID}`);
    //console.log(`  URL: ${SessionInfo.ImageStore.get(imageID) }`);
    if (SessionInfo.ImageStore.has(imageID))
      return SessionInfo.ImageStore.get(imageID);
  }
  let CD = await CallOM("GetImageAnyEnt",0,imageID,0,'','',size,10); // 10 is pageid?
  //trace(`GetImage CD: ${JSON.stringify(CD)}`);
  let imageRep = imagePrep(CD.d.Item2);
  SessionInfo.ImageStore.set(imageID,imageRep);
  return imageRep;
}
export function imagePrep(imageRaw) { // Image Preparation - NOTE 11May23 - NOT Async - setting Async makes function NOT work
  try {
    const byteCharacters = window.atob(imageRaw);
    const byteNumbers = new Array(byteCharacters.length);
    //trace(`imagePrep byteNumbers lth: ${byteCharacters.length}`);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let image = new Blob([byteArray],{ type: 'image/jpeg' }); // Convert to jpeg
    return URL.createObjectURL(image);
  } catch (ex) {
    trace(`imagePrep failed - ex: ${ex}`);
    const byteCharacters = window.atob(BlankImage);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    let image = new Blob([byteArray],{ type: 'image/jpeg' }); // Convert to jpeg
    return URL.createObjectURL(image);
  }
}

export function getDocumentType(extension,imageName) {
  let imageType = extension.toLowerCase();
  if (imageType.substring(0,1) === '.')
    imageType = imageType.substring(1);
  let ix = SessionInfo.DocumentTypes.findIndex(c => c.ddName === imageType);
  if (ix <= 0) {
    displayWarning(`Unknown Image Type: ${imageType} for ${imageName}`);
    ix = 0;
  }
  return imageType;
  //return { type: imageType, indx: ix };
}
export async function saveImageFileToServer(documentFile,imageType,tableObjID,keyID,imageOID,fileType) {
  trace(`saveImageFileToServer:  tableObjID: ${tableObjID}, Key: ${keyID}, imageOID: ${imageOID}, imageType: ${imageType} `);
  if (SessionInfo.isSavingDocument) {
    displayMessage("Document Save in Progress");
    return;
  }
  else if (!documentFile)
    displayError('A file must be selected for Document Upload');
  else {
    let iType = 2;
    switch (imageType) {
      case 'jpg':
        iType = 2;
        break;
      case 'bmp':
        iType = 1;
        break;
      case 'jpeg':
        iType = 2;
        break;
      case 'png':
        iType = 3;
        break;
      case 'gif':
        iType = 4;
        break;
      case 'wmf':
        iType = 5;
        break;
      case 'tiff':
        iType = 6;
        break;
      case 'icon':
        iType = 7;
        break;
      case 'webp': // Not currently support in 4.8
        iType = 8;
        break;
    }
    trace(`imageFile - type: ${typeof (documentFile)}`);
    SessionInfo.isSavingDocument = true;
    if (!imageOID)
      imageOID = 0;
    trace(`Saving Image for keyID: ${keyID}, ImageType: ${imageType}`);
    //trace("Save Image " + JSON.stringify(this.UploadFile));
    let CD;
    if (fileType == 1)
      CD = await CallOM("SaveImage",tableObjID,keyID,20,documentFile,iType.toString(),imageOID); // 17
    else if (fileType == 2)
      CD = await CallOM("SaveImage",tableObjID,keyID,18,documentFile,iType.toString(),imageOID); // 17  
    else
      CD = await CallOM("SaveImage",tableObjID,keyID,22,documentFile,iType.toString(),imageOID); // 17
    trace(`Saved Image Lth: ${documentFile.length}`);
    SessionInfo.isSavingDocument = false;
    let ival = CD.d;
    return ival;
  }
}
//--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export async function PingApp() { // Note - See GetAppNotifications in CheckoutMdx
  if (SessionInfo.CurrentlyInRecommendation === true) {
    if (SessionInfo.AsyncTxID && SessionInfo.AsyncCounter > 100) {
      console.log(`Wine Recommendation Timout - SessionInfo.AsyncTxID: ${SessionInfo.AsyncTxID}, Counter: ${SessionInfo.AsyncCounter}`);
      SessionInfo.AsyncTxID = 0;
      SessionInfo.CurrentlyInRecommendation = false;
      displayError("Wine Recommendation Timout - Please try again");
    }
    else
      console.log(`PingApp Skipped - Currently in Recommendation - SessionInfo.AsyncTxID: ${SessionInfo.AsyncTxID}, Counter: ${SessionInfo.AsyncCounter}`);
  } else {
  //  let CD = await CallOM("PingApp",SessionInfo.StoreLocationID,SessionInfo.CustomOrderID,CTYP.STR,"");
  //  if (CD && CD.d && CD.d.rows) {
  //    let rows = CD.d.rows;
  //    if (rows.length > 0)
  //      trace(`Return from PingApp with Notifications - CD: ${JSON.stringify(CD)}`);
  //    for (let ix = 0; ix < rows.length; ix++) {
  //      let row = rows[ix];
  //      SetNotify(row["NotificationMessage"],row["NotificationTypeID"]);
  //      SessionInfo.AppNotificationID = row["AppNotificationID"];
  //    }
  //  }
  }
}
//--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// Notify Message Processing
//--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const NOTIFY = { Message: 1,Information: 2,Warn: 3,Error: 4,Notify: 5,Table: 6,Important: 8,Problem: 9,Alert: 10,Action: 11,Abandonment: 12,Promotion: 13,Special: 14,Change: 15,Return: 16,Cancel: 20 };

export function SetNotify(message,notifyType) { // Note - See GetAppNotifications in CheckoutMdx
  try {
    if (!String.prototype.trim) { // Example! Injects function into type String
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g,'');
      };
    }
    if (message) message = message.trim();
    if (message && message.length > 4) {
      message = message.trim();
      let notifyMessage;
      let notifyTime = 20;
      SessionInfo.notifyRing = undefined;
      if (message.length > 240)
        message = message.substring(0,240) + " ...";
      switch (notifyType) {
        case NOTIFY.Message:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.acknowledge = false;
          break;
        case NOTIFY.Information:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.acknowledge = false;
          break;
        case NOTIFY.Warn:
          notifyMessage = `<br/><div style='font-size:16px; color:#e68a00; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          //SessionInfo.notifyRing = SessionInfo.bellSound1;
          SessionInfo.acknowledge = false;
          break;
        case NOTIFY.Error:
          notifyMessage = `<br/><div style='font-size:18px; color:red; margin-left:10px; margin-left:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound1;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Notify:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Table:
          notifyMessage = `<br/><div style='font-size:16px; color:#00b300; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound3;
          SessionInfo.acknowledge = true;
          SessionInfo.SoundOverride = true;
          notifyTime = 40;
          break;
        case NOTIFY.Important:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Problem:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Alert:
          notifyMessage = `<br/><div style='font-size:16px; color:#800080; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Action:
          notifyMessage = message;
          SessionInfo.acknowledge = false;
          break;
        case NOTIFY.Abandonment:
          notifyMessage = `<br/><div style='font-size:16px; color:red; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.acknowledge = false;
          break;
        case NOTIFY.Promotion:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Special:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Change:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Return:
          notifyMessage = `<br/><div style='font-size:16px; color:black; margin-left:10px; margin-right:5px;'>${message}</div><br/>`;
          SessionInfo.notifyRing = SessionInfo.bellSound2;
          SessionInfo.acknowledge = true;
          break;
        case NOTIFY.Cancel:
          notifyMessage = ``;
          notifyTime = 0;
          SessionInfo.acknowledge = false;
      }
      SessionInfo.notifyTime = notifyTime;
      trace(`Notify Message: ${notifyMessage}, type: ${notifyType}, time: ${notifyTime}`);
      SessionInfo.notifyMessage = notifyMessage;
      SessionInfo.setShowNotify = notifyType;
    }
  } catch (ex) {
    trace(`setNotify failed - message: ${message}, type: ${notifyType}, ex: ${ex}`);
  }
}
// Display Message(s) returned from OM
export function displayCDMessage(CD) {
  if (CD.x.m && CD.x.m !== '')
    trace(`display CD Message: '${CD.x.m}' - o: ${CD.x.o}`);
  if (CD.x.o >= 9000) {
    if (CD.x.o >= 9800) { // Error - Red
      displayError(CD.x.m);
      SessionInfo.flagLevel = 3;
    }
    else if (CD.x.o >= 9500) { // Warning - Yellow
      displayWarning(CD.x.m);
      SessionInfo.flagLevel = 2;
    }
    else { // Message - Green 
      SessionInfo.flagLevel = 1;
      if (CD.x.o < 9005 || SessionInfo.debug === true)
        displayMessage(CD.x.m);
    }
    //  if (SessionInfo.session !== '')
    //    CD.x.m = ''; // Only erase the message if currently in session
  }
  else {
    //trace("display CD Message: '" + CD.x.m + "' - o: " + CD.x.o);
    if (CD.x.m !== "")
      SessionInfo.flagLevel = 0;
  }
}
// Note - this is from manager!
export function displayMessage(message) {
  if (message && message.length > 4) {
    SetNotify(message,NOTIFY.Message);
  }
}
export function displayWarning(message) {
  try {
    if (message && message.length > 4) {
      SetNotify(message,NOTIFY.Warn);
    }
  }
  catch (error) {
    console.log("displayWarning: " + error);
  }
}
export function displayError(message) { // OMTrace
  try {
    trace(`==> displayError: ${message}`);
    if (message && message.length > 4) {
      SetNotify(message,NOTIFY.Error);
    }
  }
  catch (error) {
    console.log("displayError: " + error);
  }
}
export async function askQuestion(message) {
  SessionInfo.question = message;
}
//----- Notify Support Functions -----------------------------   
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
//export function rgbToHex(r, g, b) {
//  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
//}
export function rgbToHex(r,g,b) {
  return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
}
export function hexToRgb(hex) {
  hex = hex.trim();
  if (hex.length <= 7) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    trace(`hex result: ${result}`);
    return result ? {
      r: parseInt(result[1],16),
      g: parseInt(result[2],16),
      b: parseInt(result[3],16),
      o: 1.0
    } : 0;
  } else {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    //trace(`long result: ${result}`);
    return result ? {
      r: parseInt(result[1],16),
      g: parseInt(result[2],16),
      b: parseInt(result[3],16),
      o: (parseInt(result[4],16) / 255)
    } : null;
  }
}
export function displayHex(mesg,value) {
  if (Number.isInteger(value))
    return displayNumHex(mesg,value);
  else {
    try {
      let hexStr = toHex(value);
      trace(`${mesg}: ${hexStr}`);
    }
    catch (error) {
      console.log(`Error in displayHex: ${error}`);
    }
  }
}
export function xorEncode(data,key) {
  let keypos = 0;
  let binarydata = "";
  // Convert the string to an 8-bit binary data
  for (const c of data) {
    const xor = ((c.charCodeAt(0) ^ key.charCodeAt(keypos)) + key.length) & 0xff;
    keypos = (keypos + 1) % key.length;
    binarydata += decToBinary(xor,8);
  }
  let m = 0;
  let cipher = "";
  // Split the binary string into 4-byte chunks and assign each chunk the proper base64 value
  for (let i = 0; i < binarydata.length; i += 4) {
    const v = binToDec(binarydata.substring(i,i + 4));
    cipher += getB64FromN(v * 4 + m);
    m = (m + 1) % 4;
  }
  return cipher;
}
// Helper functions for binary and base64 conversions
function decToBinary(value,length) {
  return value.toString(2).padStart(length,"0");
}
function binToDec(binary) {
  return parseInt(binary,2);
}
function getB64FromN(n) {
  const base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  return base64Chars.charAt(n % 64);
}
//export function xorEncode(text,key) {
//  let result = "";
//  for (let i = 0; i < text.length; i++) {
//    const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
//    result += String.fromCharCode(charCode);
//  }
//  return result;
//}
export function MaskString(str,mask) {
  let mlth = mask.length;
  if (!str)
    str = '                   '.substring(0,mlth);
  //console.log(`mask str: ${str}`);
  let mpos = 0;
  let spos = 0;
  let retstr = '';
  while (mpos < mlth) {
    if (mask[mpos] === '#')
      retstr += str[spos++];
    else
      retstr += mask[mpos];
    mpos++;
  }
  //console.log(`masked str: ${retstr}`);
  return retstr;
}
export function UnmaskString(str,mask) {
  let mpos = 0;
  let spos = 0;
  let slth = str.length;
  let mlth = mask.length;
  let retstr = '';
  while (mpos < mlth && mpos < slth) {
    if (mask[mpos] === '#')
      retstr += str[mpos];
    mpos++;
    //console.log(`unmstr: ${retstr}, spos: ${spos}, mpos: ${mpos}`);
  }
  //console.log(`unmasked str: ${retstr}, mask: ${mask}, slth: ${slth}, mlth: ${mlth}`);
  return retstr;
}
export function displayNumHex(mesg,num) {
  try {
    let hexStr = numberToHex(num);
    trace(`${mesg}: ${hexStr}`);
  }
  catch (error) {
    console.log(`Error in displayNumHex: ${error}`);
  }
}
export function shortDesc(desc,lth) {
  if (!desc)
    desc = "";
  else if (desc.length > lth) {
    let max = desc.length - lth;
    if (max > 12)
      max = 12
    max += lth;
    let ix = lth;
    while (desc.substring(ix,1) !== ' ' && ix < max)
      ix++;
    desc = desc.substring(0,ix) + " ...";
  }
  return desc;
}
//----- Trace ----------------------------------- 
export async function trace(message,control) {
  try {
    if (!control || control == 0) {
      if (SessionInfo.traceDebug)
        console.log(message)
    }
    else if (control > 2) {
      if (control >= 3)
        console.warn(`warning: ${message} - control: ${control}`);
      else if (control >= 4)
        console.error(`error: ${message} - control: ${control}`);
      else
        console.log(message);
    }
    else if (control >= 10) {
      let xcntrl = control - 10;
      if (xcntrl >= 3)
        console.warn(`warning: ${message} - control: ${control}`);
      else if (xcntrl >= 4)
        console.error(`error: ${message} - control: ${control}`);
      else
        console.log(message);
      OMTrace(xcntrl,message);
    }
    else { // 1 or 2
      if (control > 1 || SessionInfo.traceDebug)
        console.log(message);
    }
  }
  catch (ex) {
    console.log(`Error in Trace: ${ex}`);
  }
}
export async function reportError(level,message) {
  if (level > 2)
    await LogOffResetMsg("Severe Error: " + message,1);
  else {
    let levelMsg = "Warning (" + SessionInfo.commErrorCount + "):";
    if (level > 1)
      levelMsg = "Rep Error: "
    if (++SessionInfo.commErrorCount > 5)
      await LogOffResetMsg(message,1);
    else
      console.log(levelMsg + message)
  }
}
//----- Trace to OM -----------------------------
export async function OMTrace(level,message) {
  let rc = -1;
  if (message) {
    if (level > 0) {
      if (level === 2)
        console.error(`Trace (${level}) : ${message} `);
      else
        console.warn(`Trace (${level}) : ${message} `);
    }
    let CD = await accessOMAPI(120,420,level,0,message);
    if (CD)
      rc = CD.x.o;
  }
  return rc;
}
export const ConsoleLog = ({ children }) => {
  console.log(children);
  return false;
};
//---------- General Functions --------------------------------------------
export function toHex(str) {
  var arr1 = [];
  for (var n = 0,l = str.length; n < l; n++) {
    var hex = Number(str.charCodeAt(n)).toString(16);
    if (hex.length === 1)
      hex = '0' + hex;
    arr1.push(hex);
  }
  return arr1.join('');
}
export function numberToHex(num) {
  var str = Number(num).toString(16);
  return str.length == 1 ? "0" + str : str;
};

export function GetFileExtension(filename) {
  //trace("filename: " + filename);
  var a = filename.split(".");
  //onsole.log("a: " + JSON.stringify(a));
  if (a.length <= 1 || (a[0] === "" && a.length === 2)) {
    return "";
  }
  return a.pop();
}
export function saveTextFile(docBuff,filename) {
  var blob = new Blob([docBuff],{ type: 'text/plain;charset=utf-8' });
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.download = filename;
  a.href = url;
  a.click();
}
export function convertDataURIToBinary(dataURI) {
  const BASE64_MARKER = ';base64,';
  var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}
// String to Binary
export function convertStringToBinary(dataString) {
  //var raw = window.atob(dataString);
  //var rawLength = raw.length;
  //var array = new Uint8Array(new ArrayBuffer(rawLength));
  //for (var i = 0; i < rawLength; i++) {
  //  array[i] = raw.charCodeAt(i);
  //}
  //return array;
  const textEncoder = new TextEncoder();
  const inputString = dataString;
  const utf8Bytes = textEncoder.encode(inputString);

  // Convert each byte to 8-bit binary
  const binaryArray = Array.from(utf8Bytes,(byte) => byte.toString(2).padStart(8,"0"));
  //const binaryString = binaryArray.join(" ");
  return binaryArray;
}

//// Example usage
//const decimalValue = 42; // Replace with your desired decimal value
//const binaryLength = 8; // Replace with the desired binary length
//const binaryResult = decToBinary(decimalValue,binaryLength);
//console.log("Binary Representation:",binaryResult);
//-------------------------------------------------------------------------------------------------
//function fromBitArrayCodec(arr) {
//  let out = [];
//  let bl = sjcl.bitArray.bitLength(arr), i, tmp;
//  for (i = 0; i < bl / 8; i++) {
//    if ((i & 3) === 0) {
//      tmp = arr[i / 4];
//    }
//    out.push(tmp >>> 24);
//    tmp <<= 8;
//  }
//  return out; //.buffer; // Convert to Array Buffer
//}   
//-------------------------------------------------------------------------------------------------
// Credit card format code
//-------------------------------------------------------------------------------------------------
var DEFAULT_CVC_LENGTH = 3;
var DEFAULT_ZIP_LENGTH = 5;
var DEFAULT_CARD_FORMAT = /(\d{1,4})/g;
var CARD_TYPES = [{
  type: 'amex',
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  maxCardNumberLength: 15,
  cvcLength: 4
},{
  type: 'dankort',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^5019/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'hipercard',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
  maxCardNumberLength: 19,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'dinersclub',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(36|38|30[0-5])/,
  maxCardNumberLength: 14,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'discover',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(6011|65|64[4-9]|622)/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'jcb',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^35/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'laser',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(6706|6771|6709)/,
  maxCardNumberLength: 19,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'maestro',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
  maxCardNumberLength: 19,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'mastercard',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'unionpay',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^62/,
  maxCardNumberLength: 19,
  cvcLength: DEFAULT_CVC_LENGTH,
  luhn: false
},{
  type: 'visaelectron',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^4(026|17500|405|508|844|91[37])/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'elo',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
  maxCardNumberLength: 16,
  cvcLength: DEFAULT_CVC_LENGTH
},{
  type: 'visa',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^4/,
  maxCardNumberLength: 19,
  cvcLength: DEFAULT_CVC_LENGTH
}];
//----------- Functions ------------------------------ 
export function getCardType(value) {
  return CARD_TYPES.filter(function (cardType) {
    return cardType.startPattern.test(value);
  })[0];
}
var getCardTypeByValue = function getCardTypeByValue(value) {
  return CARD_TYPES.filter(function (cardType) {
    return cardType.startPattern.test(value);
  })[0];
};
var getCardTypeByType = function getCardTypeByType(type) {
  return CARD_TYPES.filter(function (cardType) {
    return cardType.type === type;
  })[0];
};
var cardFromNumber = function (num) {
  var card,j,len;
  for (num = (num + "").replace(/\D/g,""),j = 0,len = cards.length; j < len; j++)
    if ((card = cards[j]).pattern.test(num))
      return card
}
var hasCardNumberReachedMaxLength = function hasCardNumberReachedMaxLength(currentValue,currentValueLength) {
  var cardType = getCardTypeByValue(currentValue);
  return cardType && currentValueLength >= cardType.maxCardNumberLength;
};
var hasCVCReachedMaxLength = function hasCVCReachedMaxLength(type,currentValueLength) {
  var cardType = getCardTypeByType(type);
  if (!cardType) {
    return currentValueLength >= DEFAULT_CVC_LENGTH;
  }
  return currentValueLength >= cardType.cvcLength;
};
var hasZipReachedMaxLength = function hasZipReachedMaxLength(type,currentValueLength) {
  return currentValueLength >= DEFAULT_ZIP_LENGTH;
};
var formatCardNumber = function formatCardNumber(cardNumber) {
  var cardType = getCardTypeByValue(cardNumber);
  if (!cardType) return (cardNumber.match(/\d+/g) || []).join('');
  var format = cardType.format;
  if (format.global) {
    return cardNumber.match(format).join(' ');
  }
  var execResult = format.exec(cardNumber.split(' ').join(''));
  if (execResult) {
    return execResult.splice(1,3).filter(function (x) {
      return x;
    }).join(' ');
  }
  return cardNumber;
};
var formatCvc = function formatCvc(cvc) {
  return (cvc.match(/\d+/g) || []).join('');
};
export function validateCard(num) {
  var card,ref;
  card = getCardTypeByValue(num);
  if (!card)
    return false;
  else
    return luhnCheck(num);
  //console.log(`validateCard - num: ${num}, cardtype: ${card.type}, lth: ${(num + "").replace(/\s+|-/g,"").length} ${card.maxCardNumberLength} luhnCheck: ${luhnCheck(num)}`);
  //return num = (num + "").replace(/\s+|-/g,""),!!/^\d+$/.test(num) && (!!(card = getCardTypeByValue(num)) && (ref = num.length,indexOf.call(card.length,ref) >= 0 && (!1 === card.luhn || luhnCheck(num))))
}
var validateCardNumber = function (num) {
  var card,ref;
  return num = (num + "").replace(/\s+|-/g,""),!!/^\d+$/.test(num) && (!!(card = getCardTypeByValue(num)) && (ref = num.length,indexOf.call(card.length,ref) >= 0 && (!1 === card.luhn || luhnCheck(num))))
}

var luhnCheck = function (num) {
  var digit,digits,j,len,odd,sum;
  for (odd = !0,sum = 0,j = 0,len = (digits = (num + "")
    .split("")
    .reverse()).length; j < len; j++)digit = digits[j],digit = parseInt(digit,10),(odd = !odd) && (digit *= 2),digit > 9 && (digit -= 9),sum += digit;
  return sum % 10 == 0
}

//------ Expiry -------
var formatExpiry = function formatExpiry(event) {
  var eventData = event.nativeEvent && event.nativeEvent.data;
  var prevExpiry = event.target.value.split(' / ').join('/');
  if (!prevExpiry) return null;
  var expiry = prevExpiry;
  if (/^[2-9]$/.test(expiry)) {
    expiry = '0' + expiry;
  }
  if (prevExpiry.length === 2 && +prevExpiry > 12) {
    var _prevExpiry = toArray(prevExpiry),
      head = _prevExpiry[0],
      tail = _prevExpiry.slice(1);
    expiry = '0' + head + '/' + tail.join('');
  }
  if (/^1[/-]$/.test(expiry)) {
    return '01 / ';
  }
  expiry = expiry.match(/(\d{1,2})/g) || [];
  if (expiry.length === 1) {
    if (!eventData && prevExpiry.includes('/')) {
      return expiry[0];
    }
    if (/\d{2}/.test(expiry)) {
      return expiry[0] + ' / ';
    }
  }
  if (expiry.length > 2) {
    var _ref = expiry.join('').match(/^(\d{2}).*(\d{2})$/) || [],
      _ref2 = slicedToArray(_ref,3),
      month = _ref2[1],
      year = _ref2[2];
    return [month,year].join(' / ');
  }
  return expiry.join(' / ');
};
const ERROR_TEXT__INVALID_EXPIRY_DATE = 'Expiry date is invalid';
const ERROR_TEXT__MONTH_OUT_OF_RANGE = 'Expiry month must be between 01 and 12';
const ERROR_TEXT__YEAR_OUT_OF_RANGE = 'Expiry year cannot be in the past';
const ERROR_TEXT__DATE_OUT_OF_RANGE = 'Expiry date cannot be in the past';

const EXPIRY_DATE_REGEX = /^(\d{2})\/(\d{4}|\d{2})$/;
const MONTH_REGEX = /(0[1-9]|1[0-2])/;

export function isExpiryInvalid(expiryDate) {
  var customExpiryErrorTexts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var splitDate = expiryDate.split('/');
  if (!EXPIRY_DATE_REGEX.test(expiryDate)) {
    return customExpiryErrorTexts.invalidExpiryDate || ERROR_TEXT__INVALID_EXPIRY_DATE;
  }
  var expiryMonth = splitDate[0];
  if (!MONTH_REGEX.test(expiryMonth)) {
    return customExpiryErrorTexts.monthOutOfRange || ERROR_TEXT__MONTH_OUT_OF_RANGE;
  }
  var expiryYear = splitDate[1];
  var date = new Date();
  var currentYear = date.getFullYear();
  var currentMonth = date.getMonth() + 1;
  currentYear.toString().slice(-2)
  if (currentYear > parseInt(expiryYear,10)) {
    return customExpiryErrorTexts.yearOutOfRange || ERROR_TEXT__YEAR_OUT_OF_RANGE;
  }
  if (parseInt(expiryYear,10) === currentYear && parseInt(expiryMonth,10) < currentMonth) {
    return customExpiryErrorTexts.dateOutOfRange || ERROR_TEXT__DATE_OUT_OF_RANGE;
  }
  return false;
}

var isZipValid = (function (zip) {
  return (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)
  );
});

var images = {
  placeholder: 'data:image/svg+xml;base64,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',
  visa: 'data:image/svg+xml;base64,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',
  mastercard: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0ibWFzdGVyY2FyZCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjMDAzNjYzIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxjaXJjbGUgaWQ9InNoYXBlIiBjeD0iMTAuNSIgY3k9IjkuNSIgcj0iNi41IiBmaWxsPSIjRUIxQzI2Ii8+ICAgICAgICA8Y2lyY2xlIGlkPSJzaGFwZSIgY3g9IjE4LjUiIGN5PSI5LjUiIHI9IjYuNSIgZmlsbD0iI0Y5OUYxQiIvPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRUY1RDIwIiBkPSJNMTQuNSA0LjM4YTYuNDkgNi40OSAwIDAgMCAwIDEwLjI0IDYuNDkgNi40OSAwIDAgMCAwLTEwLjI0eiIvPiAgICAgIDwvZz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==',
  amex: 'data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0iYW1leCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIDIpIj4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iIzFEOTFDRSIgZD0iTTI3LjU4IDE5SDMuNDJBMi40IDIuNCAwIDAgMSAxIDE2LjYyVjIuMzhBMi40IDIuNCAwIDAgMSAzLjQyIDBoMjQuMTZBMi40IDIuNCAwIDAgMSAzMCAyLjM4djE0LjI1QTIuNCAyLjQgMCAwIDEgMjcuNTggMTl6Ii8+ICAgICAgICA8cG9seWxpbmUgaWQ9InNoYXBlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjUuMDYzIDExLjg5NiA0LjU5MSAxMyAuMzYgMTMgMy42OTkgNiAxMS42NzQgNiAxMi40NzkgNy41NDYgMTMuMjMxIDYgMTYuMDY0IDYgMTcuNDkyIDYgMjMuOTgzIDYgMjQuOTAyIDYuOTYxIDI1Ljg4OSA2IDMwLjg4MiA2IDI3LjMzNyA5LjQ5MiAzMC43MjkgMTMgMjUuODk3IDEzIDI0LjgxNiAxMS45NjkgMjMuNzQ0IDEzIDE3LjQ5MiAxMyAxNi4wNjQgMTMgNi40OTYgMTMgNS45NzcgMTEuODk2Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMxRDkxQ0UiIGQ9Ik01Ljk4IDExLjk3aC0uOTIuOTJ6TTE2LjIgN2gtMi4xbC0xLjU4IDMuMzVMMTAuODIgN2gtMi4xdjQuODVMNi41NSA3SDQuNThsLTIuMzIgNWgxLjQybC40Ny0xLjE0aDIuN0w3LjM5IDEySDEwVjcuOTNMMTEuODUgMTJoMS4yMmwxLjg0LTR2NGgxLjI5Vjd6bTguNjcgMS42MkwyMy4zNyA3aC02LjAydjVIMjMuMTdsMS42NS0xLjY0TDI2LjQ4IDEyaDEuNTVsLTIuMzctMi41M0wyOC4xIDdoLTEuNjJsLTEuNjEgMS42MnpNMjEuNyAxMWgtMy4wNlY5LjloMy4wNlY4LjloLTMuMDZWOGgzLjA2di0uODVsMi4yNyAyLjI3LTIuMjcgMi4yOFYxMXpNNS41MyA3LjgybC44OCAyLjAzSDQuNThsLjk1LTIuMDN6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+'
};

//-------------------------------------------------------------------------------------------------
//export function toBitArrayCodec(bytes) {
//  var out = [], i, tmp = 0;
//  for (i = 0; i < bytes.length; i++) {
//    tmp = (tmp << 8) | bytes[i];
//    if ((i & 3) === 3) {
//      out.push(tmp);
//      tmp = 0;
//    }
//  }
//  if (i & 3) {
//    out.push(sjcl.bitArray.partial(8 * (i & 3), tmp));
//  }
//  return out;
//}
// Convert from a bitArray to an array of bytes.
//-------
//function apiFunction(query,successCallback,errorCallback) {
//  if (query === "bad query") {
//    errorCallback("problem with the query");
//  }
//  successCallback("Your query was <" + query + ">");
//}
//function apiFunctionWrapper(query) {
//  return new Promise((resolve, reject) => {
//    apiFunction(query, (successResponse) => {
//      resolve(successResponse);
//    }, (errorResponse) => {
//      reject(errorResponse)
//    });
//  });
//}
//export async function SaveToIPFS() { // save File on IPFS - onSaveToIPFS = async (event) => {  // Save File to IPFS
//  //event.preventDefault();
//  const accounts = await getEthAccounts(); //bring in user's metamask account walletAddresses
//  this.setCurrentParticipantID(accounts[0]);
//  if (this.state.ownerBalance === 0)
//    displayError('The contract must be Initialized First - Press: Init Contract Info');
//  else if (accounts[0] !== this.state.ownerAddress) {
//    console.log("Account0: " + accounts[0] + " ownerAddress: " + this.state.ownerAddress + " Current Role: " + this.state.currentRole + " isCurrOwner: " + this.state.isCurrOwner);
//    displayError('Only the Contract Owner can Save a Document');
//  }
//  else {
//    let isInitial = await CFContract.methods.isStepInitial.call({ from: accounts[0] });
//    if (this.state.isSavingDocument) {
//      displayMessage("Document Save in Progress");
//      return;
//    }
//    else if (isInitial === false)
//      displayError("Can only Save a File when in Initial State");
//    else if (!this.state.documentClear)
//      displayError('A file must be selected');
//    else if (!this.state.DocumentKey)
//      displayError('A Document Key Must be Provided');
//    else if (this.state.DocumentKey.length < 8)
//      displayError('The Document Key Must be at least 8 Characters');
//    else {
//      this.state.isSavingDocument = true;
//      displayMessage('Saving Document');
//      let ownerAddress = await CFContract.methods.getOwnerAddress().call({ from: accounts[0] });
//      if (ownerAddress === '') {
//        this.setState({ ownerAddress: accounts[0] });
//        this.state.ownerAddress = accounts[0];
//      }
//      else
//        await this.setState({ ownerAddress });
//      this.state.walletAddresses[0] = this.state.ownerAddress;
//      const key = sjcl.random.randomWords(4);
//      let saltStr = sjcl.codec.base64.fromBits(key);
//      //trace("saltStr:  " + saltStr);
//      let lth = saltStr.length;
//      //trace("saltStr lth:  " + lth);
//      if (lth > 16)
//        saltStr = saltStr.toString().substring(0, 16);
//      //trace("saltStr: " + saltStr);
//      //trace("document length: " + this.state.documentClear.length);
//      let bytes = new Uint8Array(this.state.documentClear); // Fr-1
//      //trace("bytes length: " + bytes.length);
//      let bits = toBitArrayCodec(bytes); // Fr-2
//      //trace("bits length: " + bits.length);
//      let base64bits = sjcl.codec.base64.fromBits(bits); // Fr-3 - Base64 Encode Document
//      //trace("base64bits - length: " + base64bits.length);
//      //this.saveTextFile(base64bits, 'before.txt');
//      //-----------------------------------------------------------------------------------
//      // Test decrypt and decode - Keep
//      //let docBuf = sjcl.codec.base64.toBits(base64bits); // Reduce size of document
//      //trace("docBuf-3: " + docBuf); // Bits
//      //let byteBuf = this.fromBitArrayCodec(docBuf);
//      //trace("docBuf-2: " + byteBuf);
//      //let byteBuf2 = Uint8Array.from(byteBuf);
//      //docBuf = new TextDecoder("utf-8").decode(byteBuf2.buffer);
//      //trace("docBuf-1: " + docBuf);
//      //-----------------------------------------------------------------------------------
//      //let enObj = sjcl.encrypt(this.state.DocumentKey, base64bits, { count: 2048, salt: saltStr, ks: 256 });
//      //trace("before encrypt dockey Length: " + base64bits.length); // Bits
//      let encDocumentStr = sjcl.encrypt(this.state.DocumentKey, base64bits, { salt: saltStr, ks: 256 }); //, { count: 2048, salt: saltStr, ks: 256 });
//      //trace("encrypted document Length: " + encDocumentStr.length); // Bits
//      //--------------------------------------------------------
//      //let salt = "jrEp464459dE2Tyls="; //
//      //var out = sjcl.encrypt("password", "The quick brown fox jumps over the lazy dog", { count: 2048, salt: salt, ks: 256 });
//      //trace("Encrypt Object: " + enObj);
//      //let encObj = JSON.parse(out);
//      //displayMessage("encrypt: " + encObj.ct);
//      //out = sjcl.decrypt("password", out);
//      //displayMessage("original: " + out);
//      //------------------------------------------------------------
//      let encObj = JSON.parse(encDocumentStr);
//      let encBuffer = encObj.ct;
//      //trace("Encrypted: " + buffer);
//      //trace("Plain: " + this.state.buffer);
//      //out = sjcl.decrypt("password", this.state.DocumentKey);
//      //displayMessage("encrypted: " + out);

//      this.setState({ DocumentNonce: encObj.iv }); // Nonce
//      this.setState({ DocumentSalt: saltStr });      // Salt
//      let ContractDocumentType = GetFileExtension(this.state.ContractFileName);
//      this.setState({ ContractDocumentType });
//      //encObj.ct = '';
//      encDocumentStr = JSON.stringify(encObj);
//      this.setState({ ipfsEncDocument: encDocumentStr });
//      //trace("Encrypt Str: " + encObjStr);
//      //---------------------------------------------------

//      //save document to IPFS,return its hash#, and set hash# to state
//      //https://github.com/ipfs/interface-ipfs-core/blob/master/SPEC/FILES.md#add
//      await ipfs.add(Buffer.from(encBuffer), (ipfsError, IPFSDocumentAddress) => {
//        if (ipfsError)
//          console.log("IPFS Error: " + ipfsError);
//        console.log("IPFS Doc Address: " + IPFSDocumentAddress);
//        this.setState({ IPFSDocumentAddress: IPFSDocumentAddress[0].hash });
//        this.saveDocumentInContract(); // Save the Document and supporting information in the Contract
//        // Init Contract will also save the document hash (address in IPFS)
//        if (this.state.CFProjectStatusID >= 4)
//          displayMessage("Encrypted Document (" + ContractDocumentType + ") saved on IPFS and in the Contract");
//      }); //await ipfs.add
//      if (this.state.CFProjectStatusID >= 4 && ContractDocumentType === 'pdf') {
//        // Display the file
//        var blob = new Blob([this.state.documentClear], { type: 'application/pdf' }); //"text/plain;charset=utf-8" });
//        var url = URL.createObjectURL(blob);
//        var a = document.createElement('a');
//        a.download = "loadFile.pdf";
//        a.href = url;
//        a.click();
//      }
//      this.state.isSavingDocument = true;
//    }
//  }
//}; //onSaveToIPFS  
